var _path, _path2, _path3, _path4, _polygon, _polygon2, _path5, _path6, _path7, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselSvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.47,66.63a38.83,38.83,0,1,1-44-32.75A38.78,38.78,0,0,1,160.47,66.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,68A29.59,29.59,0,1,1,117.8,43,29.57,29.57,0,0,1,151.33,68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,67c-.18,0-.49-1.23-1.29-3.41a31.22,31.22,0,0,0-4.68-8.48,30.48,30.48,0,0,0-4.65-4.76,29.75,29.75,0,0,0-6.47-4,29.14,29.14,0,0,0-8-2.31,28.13,28.13,0,0,0-4.43-.26,28.93,28.93,0,0,0-9,1.59,27.49,27.49,0,0,0-4.07,1.77A27.1,27.1,0,0,0,105,49.45a29.11,29.11,0,0,0-3.13,2.67,29.54,29.54,0,0,0-4.69,6,30,30,0,0,0-2.73,6.07A31.39,31.39,0,0,0,93,73.74c0,2.32.14,3.62,0,3.65s-.57-1.23-.84-3.6a27.34,27.34,0,0,1,.81-10.07,29.54,29.54,0,0,1,7.48-13.07,28.3,28.3,0,0,1,3.31-2.92,29,29,0,0,1,3.88-2.51,30.19,30.19,0,0,1,4.37-1.94,30.31,30.31,0,0,1,9.68-1.71,31.25,31.25,0,0,1,4.77.31A30.65,30.65,0,0,1,135,44.5,30.13,30.13,0,0,1,141.78,49a29.8,29.8,0,0,1,4.73,5.24,27.41,27.41,0,0,1,4.24,9.17C151.3,65.7,151.32,67,151.19,67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.89,89.2l.82,5.09-4.54.73-.8-5c-4.54.45-9.08-.27-11.89-1.82l1.61-5.94a18.63,18.63,0,0,0,9.33,1.81l-1.22-7.59c-5.24-.42-11.14-1.2-12.18-7.7-.77-4.81,2.07-9.51,9.11-11.48l-.8-5,4.54-.73.79,5a20.71,20.71,0,0,1,9.67,1.29l-1.37,6a19,19,0,0,0-7.34-1.25l1.24,7.73c5.23.37,11,1.17,12.07,7.57C137.69,82.55,134.89,87.19,127.89,89.2Zm-7.75-19.36-1-6.45c-2.32.93-3.06,2.4-2.82,3.9S118,69.53,120.14,69.84Zm9.57,9.7c-.26-1.59-1.72-2.24-3.78-2.61l1,6.27C129.13,82.34,129.94,81,129.71,79.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.67,143.2A18.27,18.27,0,1,1,697,127.8,18.25,18.25,0,0,1,717.67,143.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.37,143.83a13.92,13.92,0,1,1-15.77-11.74A13.91,13.91,0,0,1,713.37,143.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.3,143.4a8.42,8.42,0,0,1-.6-1.61,15,15,0,0,0-2.2-4,15.3,15.3,0,0,0-2.19-2.24,14.47,14.47,0,0,0-3-1.88,13.1,13.1,0,0,0-1.82-.67,13.75,13.75,0,0,0-2-.42,14.26,14.26,0,0,0-2.08-.12,15.66,15.66,0,0,0-2.14.21,14.43,14.43,0,0,0-2.08.54,14.88,14.88,0,0,0-1.91.83,13.34,13.34,0,0,0-1.71,1.07,13.89,13.89,0,0,0-1.47,1.26,14.2,14.2,0,0,0-2.21,2.81,13.94,13.94,0,0,0-1.28,2.86,14.53,14.53,0,0,0-.69,4.5,8.2,8.2,0,0,1,0,1.71,4,4,0,0,1-.4-1.69,13.08,13.08,0,0,1,.38-4.74,14.81,14.81,0,0,1,1.24-3.08,14.48,14.48,0,0,1,2.28-3.06,13.85,13.85,0,0,1,1.56-1.38,14.19,14.19,0,0,1,1.82-1.18,15.88,15.88,0,0,1,2.06-.91,15.17,15.17,0,0,1,2.25-.59,16.41,16.41,0,0,1,2.3-.22,15.1,15.1,0,0,1,2.25.15,13.33,13.33,0,0,1,2.12.48,13.1,13.1,0,0,1,1.93.75,14,14,0,0,1,5.42,4.56,12.91,12.91,0,0,1,2,4.32A3.89,3.89,0,0,1,713.3,143.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.35,153.82l.38,2.4-2.14.34-.37-2.33a10.28,10.28,0,0,1-5.6-.86l.76-2.8a8.84,8.84,0,0,0,4.39.86l-.57-3.57c-2.47-.2-5.24-.57-5.73-3.62-.37-2.27,1-4.48,4.28-5.4l-.38-2.38,2.14-.34.38,2.33a9.73,9.73,0,0,1,4.54.61l-.64,2.8a9,9,0,0,0-3.45-.59l.58,3.64c2.46.17,5.2.55,5.68,3.56C707,150.69,705.64,152.88,702.35,153.82Zm-3.65-9.11-.49-3c-1.09.44-1.44,1.13-1.33,1.83S697.71,144.57,698.7,144.71Zm4.5,4.57c-.12-.75-.81-1.06-1.78-1.23l.47,2.95C702.93,150.59,703.31,150,703.2,149.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,39.15a16.74,16.74,0,1,1-19-14.12A16.72,16.72,0,0,1,226,39.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.08,39.73A12.76,12.76,0,1,1,207.62,29,12.74,12.74,0,0,1,222.08,39.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,39.33a6.89,6.89,0,0,1-.55-1.47,14,14,0,0,0-2-3.66,13.79,13.79,0,0,0-2-2.05,12.41,12.41,0,0,0-2.79-1.72,12.1,12.1,0,0,0-1.66-.62,12.89,12.89,0,0,0-1.81-.38,12.6,12.6,0,0,0-3.87.08,13.23,13.23,0,0,0-1.9.49,13.93,13.93,0,0,0-1.76.76,12.49,12.49,0,0,0-1.56,1,10.76,10.76,0,0,0-1.35,1.15,12.84,12.84,0,0,0-3.2,5.19,13.75,13.75,0,0,0-.64,4.13,7.42,7.42,0,0,1,0,1.57,3.6,3.6,0,0,1-.37-1.55,11.73,11.73,0,0,1,.36-4.34A12.49,12.49,0,0,1,198,35.08a13.09,13.09,0,0,1,2.09-2.82A12.5,12.5,0,0,1,201.53,31a12.92,12.92,0,0,1,1.67-1.08,12.3,12.3,0,0,1,1.89-.83,14,14,0,0,1,2-.54,13.36,13.36,0,0,1,4.18-.07,12.17,12.17,0,0,1,1.94.44,13.84,13.84,0,0,1,1.77.69A13.33,13.33,0,0,1,218,31.53a13.07,13.07,0,0,1,2,2.26,11.89,11.89,0,0,1,1.83,4A3.67,3.67,0,0,1,222,39.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,48.89l.35,2.19-2,.32L210,49.26a9.48,9.48,0,0,1-5.14-.79l.7-2.56a8,8,0,0,0,4,.78l-.52-3.27c-2.26-.18-4.81-.52-5.25-3.32-.34-2.08.89-4.1,3.93-5L207.42,33l2-.31.34,2.14a8.87,8.87,0,0,1,4.17.56l-.59,2.56a8.14,8.14,0,0,0-3.17-.54l.54,3.34c2.25.16,4.76.5,5.2,3.26C216.2,46,215,48,212,48.89Zm-3.35-8.35-.45-2.78c-1,.4-1.32,1-1.21,1.68S207.72,40.4,208.63,40.54Zm4.13,4.18c-.11-.68-.74-1-1.63-1.12l.43,2.7C212.51,45.93,212.86,45.35,212.76,44.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,236.69a23.84,23.84,0,1,1-3.36-33.5A23.81,23.81,0,0,1,72,236.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6,233.1A18.17,18.17,0,1,1,65,207.56,18.15,18.15,0,0,1,67.6,233.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,232.65a11.08,11.08,0,0,1,1-2A19.16,19.16,0,0,0,70.88,225a18.34,18.34,0,0,0,.23-4.07,18,18,0,0,0-.86-4.59,17.14,17.14,0,0,0-1-2.34A18.14,18.14,0,0,0,68,211.75a17.84,17.84,0,0,0-1.72-2.11,17.79,17.79,0,0,0-4.43-3.41,18.82,18.82,0,0,0-2.48-1.11,16.84,16.84,0,0,0-2.54-.7,18.2,18.2,0,0,0-2.5-.32,18,18,0,0,0-8.53,1.63,19.28,19.28,0,0,0-5,3.29c-1,1-1.57,1.56-1.66,1.5s.32-.77,1.28-1.88a16.77,16.77,0,0,1,4.9-3.8,18.75,18.75,0,0,1,4.06-1.51,18.4,18.4,0,0,1,5-.5,16.75,16.75,0,0,1,2.7.29,16.3,16.3,0,0,1,2.74.72A18.17,18.17,0,0,1,62.48,205,19.25,19.25,0,0,1,65,206.66a20.71,20.71,0,0,1,2.24,2,17.92,17.92,0,0,1,1.83,2.3,17.32,17.32,0,0,1,1.41,2.46,17.06,17.06,0,0,1,1,2.53,18.12,18.12,0,0,1,.38,9.24,16.9,16.9,0,0,1-2.41,5.71C68.62,232.15,68,232.7,68,232.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.27,231.26l-2,2.48L44.09,232,46,229.57a13.4,13.4,0,0,1-4.1-6.15l3.36-1.73a11.52,11.52,0,0,0,3,5l2.94-3.7c-2-2.55-4.07-5.55-1.55-8.71,1.86-2.34,5.16-3,9-.62l2-2.45L62.84,213l-1.92,2.41a12.93,12.93,0,0,1,3.42,4.92l-3.27,1.84a11.56,11.56,0,0,0-2.47-3.84l-3,3.76c2,2.52,4,5.49,1.56,8.6C55.34,233,52.08,233.61,48.27,231.26Zm5.57-11.53,2.49-3.14c-1.38-.66-2.35-.39-2.93.34S53.11,218.65,53.84,219.73Zm-.44,8.36c.62-.78.31-1.71-.38-2.8l-2.43,3.06C51.89,229,52.84,228.79,53.4,228.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.34,336.53A23.84,23.84,0,1,1,603,303,23.82,23.82,0,0,1,606.34,336.53Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,332.93a18.17,18.17,0,1,1-2.57-25.53A18.15,18.15,0,0,1,602,332.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.31,332.49a11.12,11.12,0,0,1,1-2,19.38,19.38,0,0,0,1.91-5.63,19.06,19.06,0,0,0,.23-4.08,18.16,18.16,0,0,0-.87-4.59,17,17,0,0,0-.94-2.33,17.53,17.53,0,0,0-1.34-2.27,17,17,0,0,0-1.71-2.11,18.67,18.67,0,0,0-2.08-1.88,18.15,18.15,0,0,0-2.35-1.53,16.63,16.63,0,0,0-2.49-1.11,17.1,17.1,0,0,0-2.53-.71,16.74,16.74,0,0,0-2.5-.31,18.05,18.05,0,0,0-4.66.35,18.4,18.4,0,0,0-3.88,1.27,19.45,19.45,0,0,0-5,3.3c-1,1-1.58,1.56-1.66,1.49s.31-.77,1.27-1.87a16.81,16.81,0,0,1,4.91-3.8,18.06,18.06,0,0,1,4.06-1.52,18.36,18.36,0,0,1,5-.5,17.83,17.83,0,0,1,2.69.29,18.15,18.15,0,0,1,2.74.72,18.77,18.77,0,0,1,2.69,1.18,20.51,20.51,0,0,1,2.55,1.65,18.59,18.59,0,0,1,4.07,4.32,18.42,18.42,0,0,1,1.4,2.46,18.82,18.82,0,0,1,1,2.53,18.4,18.4,0,0,1,.79,4.93,18.71,18.71,0,0,1-.42,4.31,17,17,0,0,1-2.4,5.72C603,332,602.38,332.54,602.31,332.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.63,331.1l-2,2.47-2.21-1.75,1.91-2.41a13.42,13.42,0,0,1-4.09-6.15l3.36-1.73a11.34,11.34,0,0,0,3,5l2.94-3.69c-2-2.55-4.07-5.55-1.56-8.71,1.87-2.35,5.17-3,9-.62l2-2.46,2.21,1.76-1.91,2.41a12.79,12.79,0,0,1,3.41,4.92L595.42,322a11.56,11.56,0,0,0-2.47-3.84l-3,3.76c2,2.53,4,5.49,1.57,8.61C589.7,332.79,586.43,333.44,582.63,331.1Zm5.56-11.53,2.5-3.14c-1.38-.67-2.36-.4-2.94.33S587.47,318.48,588.19,319.57Zm-.43,8.35c.61-.77.3-1.7-.38-2.79L585,328.18C586.25,328.82,587.19,328.63,587.76,327.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.33,100.81,628.19,42.59a6.77,6.77,0,0,0-4.47-3.15L591.78,33a6.79,6.79,0,0,0-7.85,4.74L574.73,69a6.79,6.79,0,0,0,.7,5.42l36.14,58.22a6.78,6.78,0,0,0,9.31,2.31L662,110.12A6.78,6.78,0,0,0,664.33,100.81ZM599.66,54.58A6.37,6.37,0,1,1,602.4,46,6.36,6.36,0,0,1,599.66,54.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.33,100.81,628.19,42.59a6.77,6.77,0,0,0-4.47-3.15L591.78,33a6.79,6.79,0,0,0-7.85,4.74L574.73,69a6.79,6.79,0,0,0,.7,5.42l36.14,58.22a6.78,6.78,0,0,0,9.31,2.31L662,110.12A6.78,6.78,0,0,0,664.33,100.81ZM599.66,54.58A6.37,6.37,0,1,1,602.4,46,6.36,6.36,0,0,1,599.66,54.58Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.11,92.12c-3.53-5.68-2.1-11.32,2.74-14.33S608.42,76,612,81.64,614.05,93,609.17,96,598.67,97.84,595.11,92.12Zm11.17-7c-2.08-3.33-4.07-3.91-5.66-2.92s-2,3,.12,6.37,4.15,3.85,5.66,2.92S608.35,88.51,606.28,85.17Zm11.26-19,6.75-4.2-2,46.8-6.76,4.2Zm10.38,27.06c-3.53-5.68-2.15-11.29,2.73-14.33s10.58-1.82,14.11,3.85S646.85,94,642,97.07,631.48,98.91,627.92,93.19Zm11.16-7c-2.07-3.33-4.11-3.88-5.65-2.92s-2,3,.12,6.37,4.1,3.88,5.65,2.92S641.15,89.58,639.08,86.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.27,237.06l-25.93-7.46a.84.84,0,0,1-.57-1,.83.83,0,0,1,1-.56l25.26,7.27,7.39-15.09-30.52-8.79a.83.83,0,0,1-.57-1,.84.84,0,0,1,1-.57l31.47,9.06a.85.85,0,0,1,.52.46.82.82,0,0,1,0,.7l-8.13,16.6A.83.83,0,0,1,720.27,237.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.65,242.93h0L693,235.74a.83.83,0,0,1-.59-.92l4.38-28.5-7.23-2.08a.84.84,0,0,1-.57-1,.83.83,0,0,1,1-.56l7.93,2.28a.83.83,0,0,1,.59.92l-4.39,28.5,24,7a.83.83,0,0,1,.56,1A.82.82,0,0,1,717.65,242.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.45,245.77a4,4,0,1,1,5-2.76A4,4,0,0,1,694.45,245.77Zm1.77-6.15a2.37,2.37,0,1,0,1.63,2.94A2.38,2.38,0,0,0,696.22,239.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.5,250.68a4,4,0,1,1,5-2.76A4,4,0,0,1,711.5,250.68Zm1.77-6.15a2.37,2.37,0,1,0,1.62,2.93A2.38,2.38,0,0,0,713.27,244.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.34,231.9a.82.82,0,0,1-.57-1l3.81-17.23a.83.83,0,1,1,1.62.36l-3.82,17.22a.82.82,0,0,1-1,.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.83,234.63h-.05a.84.84,0,0,1-.51-1.06l5.82-16.65a.83.83,0,0,1,1.56.54l-5.81,16.66A.83.83,0,0,1,711.83,234.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.29,220.71a.84.84,0,0,1-.57-1,.82.82,0,0,1,1-.57l29,8h0a.83.83,0,1,1-.45,1.59l-29-8Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4,403.27c0-.15,144.89-.26,323.58-.26s323.62.11,323.62.26-144.86.26-323.62.26S51.4,403.41,51.4,403.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.69,267.87c-7.13,3.69-12.61,10.06-16.54,17.06s-6.47,14.7-9,22.33L62,346.62c8.3-14.12,15-30.72,16.77-47l-5.53-.49c3.71-.56,6.82-3.25,8.79-6.43s3-6.85,4-10.46l-6.73,1A25,25,0,0,0,89.69,267.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.69,267.87c-7.13,3.69-12.61,10.06-16.54,17.06s-6.47,14.7-9,22.33L62,346.62c8.3-14.12,15-30.72,16.77-47l-5.53-.49c3.71-.56,6.82-3.25,8.79-6.43s3-6.85,4-10.46l-6.73,1A25,25,0,0,0,89.69,267.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M60.74,355.84s-18-21.56-17.81-42.15h7.28s-7.9-5.2-7.28-8.11.84-13.94.84-13.94l6.65,1.67s-5-2.5-5.61-6.45,1.45-22.25,1.45-22.25,8.11,8.53,10.61,17.26,9,18.92,7.12,45.54S60.74,355.84,60.74,355.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.88,357.88s19.52-13,23.86-29.6l-5.85-1.6s7.49-2.45,7.62-4.92,2.38-11.39,2.38-11.39l-5.71-.12s4.56-.91,5.92-3.95,3.7-18.21,3.7-18.21-8.39,5.08-12.3,11.56S78.08,312.88,73.81,334.7,69.88,357.88,69.88,357.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.18,283.41a.74.74,0,0,1,.08.22c0,.18.1.4.16.67.15.62.34,1.48.59,2.55.51,2.22,1.18,5.45,2,9.45,1.54,8,3.36,19.11,4.79,31.46s2.19,23.59,2.51,31.73c.17,4.07.25,7.36.26,9.64,0,1.1,0,2,0,2.62,0,.27,0,.5,0,.68s0,.23,0,.23,0-.07,0-.23,0-.41,0-.68c0-.64-.06-1.51-.11-2.62-.07-2.27-.21-5.56-.43-9.63-.41-8.12-1.23-19.34-2.66-31.68S55,304.38,53.59,296.37c-.72-4-1.33-7.24-1.78-9.48-.2-1.08-.37-1.94-.49-2.57,0-.27-.08-.49-.11-.67A1.36,1.36,0,0,1,51.18,283.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.25,369.05s-16.49-18.71-21.61-30l3.86-1.65a10,10,0,0,1-7.84-2.57,29.86,29.86,0,0,1-5.33-6.6l5.09-.87a18.9,18.9,0,0,1-11.13-8.61c6,1,11.45,4.29,15.93,8.41a79.8,79.8,0,0,1,9.64,11.18,37.94,37.94,0,0,1,3.75,6.16C53.38,350.21,58.25,362.18,58.25,369.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,299a6.74,6.74,0,0,1-.32.74l-1,2.09c-.88,1.8-2.12,4.41-3.63,7.66-3,6.49-7,15.54-10.95,25.72s-7.07,19.57-9.2,26.4c-1.07,3.42-1.91,6.19-2.48,8.11l-.67,2.2a4.5,4.5,0,0,1-.26.76,4.6,4.6,0,0,1,.16-.78c.15-.56.34-1.3.58-2.24.5-1.93,1.29-4.72,2.32-8.16,2-6.86,5.13-16.27,9.07-26.48s8-19.23,11.1-25.69c1.55-3.23,2.84-5.82,3.77-7.59q.67-1.29,1.08-2A3.79,3.79,0,0,1,94,299Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.64,377.07a7.8,7.8,0,0,1-.27-1.34c-.14-.86-.36-2.1-.67-3.63a77.28,77.28,0,0,0-3.36-11.68,76.33,76.33,0,0,0-5.2-11c-.78-1.35-1.43-2.43-1.9-3.16a7,7,0,0,1-.67-1.19,6.51,6.51,0,0,1,.84,1.07c.52.71,1.22,1.76,2.05,3.1a66.38,66.38,0,0,1,5.37,11A66,66,0,0,1,59.06,372c.26,1.55.43,2.8.51,3.68A6.34,6.34,0,0,1,59.64,377.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.31,
    y: 372.66,
    width: 36.09,
    height: 7.36,
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.75 380.03 52.66 404.79 74.46 404.79 78.1 380.03 48.75 380.03",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.19,380c0,.14-6.83.26-15.25.26s-15.25-.12-15.25-.26,6.83-.26,15.25-.26S79.19,379.88,79.19,380Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gift--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.88,361.42s-7.31.43-7.9,1.7c0,0-.09,5.39,5.08,10.81l-1,2.21v3.59c2.41-4.67,5.1-11.81,5.1-11.81S511.25,362.9,509.88,361.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M509.62,361.9s-2.55,6.63-1,11.4C508.64,373.3,512.14,367.45,509.62,361.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M521.12,370.35s-3.39-6.49-4.8-6.5c0,0-4.94,2.12-7.76,9.07l-2.43,0a14,14,0,0,0-7.79-8.65s-3.71,6.69-3.83,6.62a13.16,13.16,0,0,0,8.35,3.5c5.24.27,12.86-.21,12.86-.21S520.34,372.2,521.12,370.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M504.87,373.8s-5.48-3.16-9.91-2.87C495,370.93,500.09,375.26,504.87,373.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M520.58,370.31s-7.09.4-10.8,3.79C509.78,374.1,516.57,374.89,520.58,370.31Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "531.79 374.14 529.85 403.27 484.89 402.85 484.54 373.7 531.79 374.14",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "523.26 374.06 522.99 403.2 529.85 403.27 531.79 374.14 523.26 374.06"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "528.41 374.11 526.99 403.24 525.43 403.23 525.71 374.08 528.41 374.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.56,
    y: 386.58,
    width: 29.14,
    height: 3.75,
    transform: "matrix(0.01, -1, 1, 0.01, 110.97, 888.92)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.7,
    y: 386.54,
    width: 46.08,
    height: 2.83,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bag-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.17,346.26a36.71,36.71,0,0,0-1.39-6.65,19.34,19.34,0,0,0-3.18-6.1,7.47,7.47,0,0,0-12.46-.05,19.33,19.33,0,0,0-3.2,6.08,37.93,37.93,0,0,0-1.41,6.64,3.11,3.11,0,0,1,0-.49c0-.32,0-.78.11-1.38a26.44,26.44,0,0,1,1-4.92,19.46,19.46,0,0,1,3.21-6.29,8.44,8.44,0,0,1,6.5-3.5,8.53,8.53,0,0,1,6.48,3.55,19.31,19.31,0,0,1,3.19,6.32,25.48,25.48,0,0,1,1,4.92,12.57,12.57,0,0,1,.1,1.38A1.56,1.56,0,0,1,554.17,346.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.91,346.26a37.83,37.83,0,0,0-1.39-6.65,19.55,19.55,0,0,0-3.18-6.1,7.47,7.47,0,0,0-12.46-.05,19.36,19.36,0,0,0-3.21,6.08,36.14,36.14,0,0,0-1.4,6.64,1.56,1.56,0,0,1,0-.49c0-.32,0-.78.1-1.38a25.8,25.8,0,0,1,1-4.92,19.46,19.46,0,0,1,3.21-6.29,8.44,8.44,0,0,1,6.5-3.5,8.53,8.53,0,0,1,6.48,3.55,19.71,19.71,0,0,1,3.19,6.32,26.27,26.27,0,0,1,1,4.92c.06.6.09,1.06.1,1.38A3.11,3.11,0,0,1,557.91,346.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.97 343.37 562.17 343.04 563.09 403.01 515.73 403.01 519.97 343.37",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "562.17 343.04 567.47 343.04 572.03 403.01 563.09 403.01 562.17 343.04",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.35,
    y: 363.41,
    width: 27.63,
    height: 6.06,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "562.17 343.04 567.47 343.04 572.03 403.01 563.09 403.01 562.17 343.04"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M515.73,403c-.14,0,.44-10.37,1.3-23.14s1.68-23.12,1.82-23.11-.43,10.37-1.3,23.14S515.88,403,515.73,403Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540.68,64.94H161.45a11.83,11.83,0,0,0-11.84,11.83V344.63a11.84,11.84,0,0,0,11.84,11.84H307l-7.06,46.8H405.47l-5.89-46.8h141.1a11.84,11.84,0,0,0,11.84-11.84V76.77A11.83,11.83,0,0,0,540.68,64.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.13,328.3c5.16,7.37-2.92,15.45-10.29,10.29a2.43,2.43,0,0,1-.64-.64c-5.14-7.37,2.92-15.43,10.29-10.28A2.56,2.56,0,0,1,356.13,328.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.91,75.16H532.26a9.7,9.7,0,0,1,9.7,9.7V307.47a0,0,0,0,1,0,0H160.22a0,0,0,0,1,0,0V84.86A9.7,9.7,0,0,1,169.91,75.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.7,356.47c0,.13-31.79.24-71,.24s-71-.11-71-.24,31.79-.23,71-.23S438.7,356.35,438.7,356.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.57,
    y: 84.76,
    width: 361.49,
    height: 213.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.57,
    y: 84.76,
    width: 361.49,
    height: 17.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.62,94a2.54,2.54,0,1,1-2.54-2.46A2.5,2.5,0,0,1,184.62,94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,94a2.54,2.54,0,1,1-2.54-2.46A2.5,2.5,0,0,1,192.19,94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.39,94a2.54,2.54,0,1,1-2.54-2.46A2.5,2.5,0,0,1,199.39,94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 128.84,
    width: 361.63,
    height: 76.19,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.34,
    y: 112.82,
    width: 35.34,
    height: 9,
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.71,
    y: 110.78,
    width: 25.59,
    height: 9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.88,
    y: 110.54,
    width: 25.59,
    height: 9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.82,194.42a3.22,3.22,0,1,1-3.21-3.11A3.16,3.16,0,0,1,337.82,194.42Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.62,194.42a3.22,3.22,0,1,1-3.21-3.11A3.16,3.16,0,0,1,350.62,194.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.84,194.42a3.22,3.22,0,1,1-3.21-3.11A3.16,3.16,0,0,1,362.84,194.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.84,
    y: 185.18,
    width: 94.59,
    height: 9.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.48,
    y: 218.88,
    width: 54.66,
    height: 47.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.24,
    y: 218.03,
    width: 46.09,
    height: 46.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.93,
    y: 216.61,
    width: 48.92,
    height: 48.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.43,230.76s-13.7-15.49-15.43-16.48a13.66,13.66,0,0,0-3.76-1.09,17.15,17.15,0,0,0-2.28-.33h-.15c-4.2-.37-10.56-.19-10.56-.19s-.11,5.59-7.24,7.94c-7.33,1.6-10.27-3.17-10.27-3.17s-5.57,3.07-9,5.52h0l-.13.09a17.05,17.05,0,0,0-1.8,1.44,13.53,13.53,0,0,0-2.69,2.85c-1,1.73-4.93,22-4.93,22l14.67,2.94,1.49-10,7.92,32.58,17.43-4.75,1.48-.41,17.64-4.81-9.91-32,6.36,7.86Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.54,250.3a21.3,21.3,0,0,1-.91-2.93c-.5-1.83-1.17-4.4-1.91-7.29l.05.08-.86-1.13c-2-2.66-3.79-5.08-5.06-6.84-.63-.88-1.14-1.6-1.48-2.11a3.75,3.75,0,0,1-.5-.81,3.49,3.49,0,0,1,.65.69c.39.47.94,1.16,1.61,2,1.35,1.71,3.18,4.09,5.18,6.74l.85,1.15,0,0v0c.72,2.91,1.33,5.48,1.75,7.34A20,20,0,0,1,219.54,250.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,240.89a20.2,20.2,0,0,1-1-2.88c-.58-1.81-1.36-4.35-2.22-7.21v-.1c.06-.45.11-.93.16-1.42.38-3.3.75-6.28,1-8.44.14-1.08.27-2,.37-2.55a4.07,4.07,0,0,1,.2-.93,3.21,3.21,0,0,1,0,.95c0,.61-.11,1.49-.21,2.57-.2,2.17-.51,5.16-.89,8.46-.05.49-.11,1-.16,1.42v-.1c.84,2.87,1.56,5.42,2.06,7.25A20.91,20.91,0,0,1,254,240.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.16,228.33h11a0,0,0,0,1,0,0v7a4.94,4.94,0,0,1-4.94,4.94H243.1a4.94,4.94,0,0,1-4.94-4.94v-7a0,0,0,0,1,0,0Z",
    transform: "translate(-52.86 72) rotate(-15.18)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.38,240.38a5,5,0,0,1-4.79-3.67L236.76,230h0l10.62-2.88v0l1.83,6.72a5,5,0,0,1-3.5,6.1l-1,.28A4.85,4.85,0,0,1,243.38,240.38ZM236.82,230l1.82,6.71a4.92,4.92,0,0,0,6,3.46l1.05-.29a4.92,4.92,0,0,0,3.46-6l-1.82-6.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,239.73s.36-.13.94-.46a4.39,4.39,0,0,0,2.16-4.07,14.85,14.85,0,0,0-.55-2.3c-.47-1.66-1-3.49-1.53-5.46l.29.17-5.86,1.61-4.3,1.16.17-.3c.58,2.18,1.13,4.21,1.62,6.06.13.46.23.92.38,1.31a4.22,4.22,0,0,0,2.36,2.4,4.72,4.72,0,0,0,3.15.12,6.42,6.42,0,0,1,1.17-.24,6,6,0,0,1-1.13.4,4.7,4.7,0,0,1-3.31,0A4.6,4.6,0,0,1,239,237.6a12.42,12.42,0,0,1-.42-1.35c-.51-1.84-1.08-3.87-1.68-6l-.06-.23.23-.07,4.3-1.17,5.87-1.59.23-.07.06.24c.53,2,1,3.81,1.46,5.48a13.22,13.22,0,0,1,.52,2.38,4.76,4.76,0,0,1-.41,2.09,4.46,4.46,0,0,1-2,2.14,3.6,3.6,0,0,1-.74.28C246.14,239.73,246.05,239.75,246,239.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.71,
    y: 276.51,
    width: 47.68,
    height: 6.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.35,
    y: 276.51,
    width: 47.68,
    height: 6.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.05,
    y: 276.67,
    width: 45.27,
    height: 6.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.83,255.78c-.57-2-3.16-2-5.05-2.85a56.07,56.07,0,0,1-13.24-8.17L432,242l-.15,1.63C441.09,257,458.2,266.81,474.43,266a27,27,0,0,0,12.48-3.32C489,261.37,491.51,258.16,490.83,255.78Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M490.83,255.78c-.57-2-3.16-2-5.05-2.85a56.07,56.07,0,0,1-13.24-8.17L432,242l-.15,1.63C441.09,257,458.2,266.81,474.43,266a27,27,0,0,0,12.48-3.32C489,261.37,491.51,258.16,490.83,255.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M474.71,234.21c-2-4.8-4.87-9.31-10.21-11.7A23.07,23.07,0,0,0,443.72,224c-6.06,3.53-10.84,12.3-11.86,18.61,13.93,12.72,41.76,15,46.11,7.15C478.5,244.8,476.74,239,474.71,234.21Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.7,255c-.57-2-2.74-3-4.63-3.79a56.28,56.28,0,0,1-13.24-8.17l-41-.47c9.27,13.35,26.63,22.52,42.86,21.66A27,27,0,0,0,487.2,261C489.32,259.69,491.38,257.42,490.7,255Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.42,247.16a1.86,1.86,0,0,1-.05.52,8.77,8.77,0,0,1-.43,1.47,8.19,8.19,0,0,1-3.74,4.1,13.21,13.21,0,0,1-3.65,1.31,20.79,20.79,0,0,1-2.14.31c-.74.08-1.5.14-2.28.15a44.13,44.13,0,0,1-10.1-1,59.86,59.86,0,0,1-17.17-6.5,55.55,55.55,0,0,1-4.68-3l-1.2-.93a2.25,2.25,0,0,1-.39-.35,2,2,0,0,1,.46.26l1.25.85c1.09.73,2.7,1.73,4.74,2.88a63.62,63.62,0,0,0,17.1,6.31,44.92,44.92,0,0,0,10,1,20.62,20.62,0,0,0,2.25-.13,19.39,19.39,0,0,0,2.1-.27,13.26,13.26,0,0,0,3.57-1.21,8.15,8.15,0,0,0,3.72-3.86A20,20,0,0,0,478.42,247.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.28,254.55a5.47,5.47,0,0,1,0-.71q0-.78,0-2c.07-1.77,0-4.34-.13-7.49a51.16,51.16,0,0,0-1.82-10.92,28.48,28.48,0,0,0-2.51-6,13.94,13.94,0,0,0-4.68-5,4.78,4.78,0,0,0-.68-.34h.14a14.84,14.84,0,0,0-6.15,2.78,27.73,27.73,0,0,0-4.46,4.55,41.17,41.17,0,0,0-5.72,9.15c-1.29,2.8-2.11,5.16-2.72,6.78l-.71,1.86a3.75,3.75,0,0,1-.27.63,2.84,2.84,0,0,1,.18-.67c.15-.48.36-1.11.61-1.89.55-1.63,1.32-4,2.57-6.86a40.53,40.53,0,0,1,5.69-9.3,27.46,27.46,0,0,1,4.52-4.65,15.25,15.25,0,0,1,6.35-2.89l.08,0,.06,0a4.54,4.54,0,0,1,.77.37,14.47,14.47,0,0,1,4.86,5.21,28.45,28.45,0,0,1,2.53,6.12,50,50,0,0,1,1.73,11,72,72,0,0,1,0,7.53c-.05.84-.09,1.52-.13,2A2.88,2.88,0,0,1,469.28,254.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.72,220.29H460a1.14,1.14,0,0,1,1.14,1.14v.89a0,0,0,0,1,0,0h-2.53a0,0,0,0,1,0,0v-.89A1.14,1.14,0,0,1,459.72,220.29Z",
    transform: "translate(44.45 -75.14) rotate(9.81)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,241.08l-1,4.61s6.09,3.32,11.82,2.18a8.7,8.7,0,0,0,5.36-3l-.39-4s-1.63,1.87-6.55,2C464.58,243,459,241.08,459,241.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.81,259.58s-.09.12-.31.31a8.48,8.48,0,0,1-1,.79,17.77,17.77,0,0,1-4.16,2.15,34.55,34.55,0,0,1-15.26,1.73,46.68,46.68,0,0,1-14.76-4.33c-1.78-.85-3.18-1.61-4.13-2.17-.48-.27-.84-.5-1.09-.65a1.61,1.61,0,0,1-.36-.26,10.55,10.55,0,0,1,1.54.74c1,.5,2.4,1.21,4.2,2A49.33,49.33,0,0,0,468.14,264a36.08,36.08,0,0,0,15.07-1.55A22.86,22.86,0,0,0,488.81,259.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.4,233s5.45-10.29,12.07-11c0,0,12.21,7,14.08,6.55s-.85-4,1.72-6,5.15.24,6.2,1.78,8.41,18.35,14.64,22.63,16,12.86,14.44,16.72c-1.18,2.88-.87,1.83-6.39,2.87s-23.8-7.77-29.69-13.76C338.22,243.48,326.47,233.53,320.4,233Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.33,267.76a1.25,1.25,0,0,0-.79-2.33,5.87,5.87,0,0,1-1,.11c-3.74.12-8.55-1.31-14.52-3.9s-8.14-4.3-15.7-10S335.51,236,329.56,234.3a27.09,27.09,0,0,0-8.87-1.3,1.11,1.11,0,0,0-.53.17c-4.14,2.49-11.79,12.36-7.82,15,2.75,1.81,12.27,3,19,5.3s21.47,8.81,29.84,11.71,16.89,4.2,20.1,2.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.33,267.76a1.29,1.29,0,0,1-.39.19,6,6,0,0,1-1.2.37,18.23,18.23,0,0,1-4.82.13,64.36,64.36,0,0,1-17.18-4.33c-7-2.61-15.2-6.16-24.43-9.69-4.6-1.83-9.7-2.8-14.95-4-1.31-.32-2.64-.64-3.95-1.07a11.37,11.37,0,0,1-2-.82,2.64,2.64,0,0,1-1.37-1.73,6.77,6.77,0,0,1,.77-4.23,21.55,21.55,0,0,1,2.22-3.68,29.1,29.1,0,0,1,2.77-3.28,16.5,16.5,0,0,1,3.31-2.72,2.94,2.94,0,0,1,1.13-.15c.35,0,.7,0,1,0,.7,0,1.39.1,2.08.19a33.24,33.24,0,0,1,4,.8,12.33,12.33,0,0,1,3.76,1.52,23.48,23.48,0,0,1,3.15,2.42c1.94,1.74,3.66,3.61,5.37,5.4A69.43,69.43,0,0,0,351,252.58a80.54,80.54,0,0,0,10,6.93c6.64,3.37,12.43,5.43,16.58,5.86a12,12,0,0,0,2.75,0,1.47,1.47,0,0,1,1.12.17,1.35,1.35,0,0,1,.53.79,1.21,1.21,0,0,1-.31,1.19,1,1,0,0,1-.26.19l-.1,0a2.73,2.73,0,0,0,.32-.27,1.15,1.15,0,0,0,.25-1.13,1.25,1.25,0,0,0-.5-.7,1.34,1.34,0,0,0-1-.13,11.2,11.2,0,0,1-2.8,0,31.49,31.49,0,0,1-7.43-1.76,71.56,71.56,0,0,1-9.3-4,78.38,78.38,0,0,1-10.13-6.91,49.87,49.87,0,0,1-5.27-4.36c-1.71-1.61-3.38-3.36-5.08-5.16s-3.44-3.64-5.35-5.36a23.49,23.49,0,0,0-3.08-2.36,11.67,11.67,0,0,0-3.63-1.46,34.65,34.65,0,0,0-4-.78c-.67-.09-1.35-.15-2-.18-.34,0-.68,0-1,0a2.51,2.51,0,0,0-.92.1,16.42,16.42,0,0,0-3.16,2.61,30.05,30.05,0,0,0-2.72,3.22,21.79,21.79,0,0,0-2.17,3.6,6.43,6.43,0,0,0-.74,3.88c.27,1.3,1.75,1.74,3,2.19s2.6.75,3.91,1.06c5.22,1.24,10.37,2.23,15,4.08,9.25,3.57,17.41,7.14,24.4,9.79a66,66,0,0,0,17.06,4.48,19.39,19.39,0,0,0,4.79,0,7,7,0,0,0,1.2-.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.8,238c0,.15-1.28.35-2.76.93s-2.57,1.29-2.66,1.17a5,5,0,0,1,2.48-1.65A4.86,4.86,0,0,1,361.8,238Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.42,241.61a8.62,8.62,0,0,1-2.48,1.71,9.05,9.05,0,0,1-2.74,1.26,8.8,8.8,0,0,1,2.48-1.71A9.17,9.17,0,0,1,364.42,241.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.38,245.21c.09.12-.73.93-1.73,1.92s-1.84,1.78-1.95,1.69.56-1.06,1.58-2.07S367.29,245.1,367.38,245.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.3,
    y: 242.05,
    width: 9.1,
    height: 2.22,
    rx: 1,
    transform: "translate(79.88 -80.08) rotate(16.06)",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,222.87a5.65,5.65,0,0,0-1-2.35,1.5,1.5,0,0,0-.89-.7,1.76,1.76,0,0,0-1.16.38l-.95.6c-.2.13-.42.28-.44.51a.76.76,0,0,0,.17.48l1.39,2.14",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.47,222.06c0,.09-.89.35-2.25,1a21.29,21.29,0,0,0-4.81,3.43,23.75,23.75,0,0,0-3.76,4.58c-.8,1.29-1.19,2.16-1.27,2.13a7.56,7.56,0,0,1,.95-2.32,19.37,19.37,0,0,1,3.73-4.76,17.41,17.41,0,0,1,5-3.39A6.63,6.63,0,0,1,332.47,222.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.78,223.65c-.15,0-.39-.64-1-1.27s-1.18-1-1.13-1.12.87,0,1.53.78S328.92,223.64,328.78,223.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M347.11,228.17c.14-.46,5.47,8.3,9.07,11.71-4-2.95-8.12-7.72-11.27-11.58C344.91,228.3,346.79,229.23,347.11,228.17Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M369.2,249.34a1.68,1.68,0,0,1-.73.34,5.42,5.42,0,0,1-2.2.19,7.74,7.74,0,0,1-3.09-1.06,13.14,13.14,0,0,1-3-2.59c-.46-.53-.89-1.07-1.29-1.59s-.74-1-1.09-1.55L356,240.44a17,17,0,0,1-1.57-2.51,16.83,16.83,0,0,1,1.87,2.29c.57.78,1.21,1.64,1.91,2.57l1.11,1.53c.4.51.83,1,1.28,1.55a13.38,13.38,0,0,0,2.88,2.53,7.72,7.72,0,0,0,2.89,1.1A8.05,8.05,0,0,0,369.2,249.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.92,238.38a3.1,3.1,0,0,1-.22-1,14,14,0,0,1-.1-2.76,15.69,15.69,0,0,1,.76-4,14.6,14.6,0,0,1,.92-2.25,10.78,10.78,0,0,1,.63-1.14,2.05,2.05,0,0,1,.53-.53,1,1,0,0,1,.84-.12,1.49,1.49,0,0,1,.85,1.25,8.4,8.4,0,0,1,.08,1.3,12.65,12.65,0,0,1-.2,2.43,13.32,13.32,0,0,1-1.35,3.88,11.79,11.79,0,0,1-1.57,2.28,2.92,2.92,0,0,1-.73.69,26.2,26.2,0,0,0,2-3.13,13.82,13.82,0,0,0,1.2-3.8,11.89,11.89,0,0,0,.17-2.34,8.15,8.15,0,0,0-.08-1.22c-.06-.38-.24-.77-.5-.85s-.56.13-.78.46a11,11,0,0,0-.61,1.07,16.56,16.56,0,0,0-.92,2.17,17.14,17.14,0,0,0-.84,3.91C359.75,237,360,238.37,359.92,238.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,238.17a3.82,3.82,0,0,1,.62-.84c.43-.51,1.06-1.25,1.9-2.11a19.74,19.74,0,0,1,3.22-2.74,13,13,0,0,1,2.21-1.21,4.3,4.3,0,0,1,1.33-.4,1.51,1.51,0,0,1,1.43.59,1.77,1.77,0,0,1,.14,1.53,4.16,4.16,0,0,1-.7,1.2,8.47,8.47,0,0,1-1.89,1.72,12.33,12.33,0,0,1-3.91,1.65,23,23,0,0,1-2.8.51,4.06,4.06,0,0,1-1,.08c0-.1,1.46-.32,3.74-.94a13,13,0,0,0,3.74-1.7,8.14,8.14,0,0,0,1.75-1.63c.52-.63.95-1.48.53-2.13a1,1,0,0,0-.95-.36,3.73,3.73,0,0,0-1.17.35,13.68,13.68,0,0,0-2.15,1.14,24,24,0,0,0-3.23,2.6C361,237.13,360,238.23,360,238.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.67,
    y: 105.33,
    width: 34.89,
    height: 34.89,
    rx: 3.84,
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.93,125.82H498.4a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h11.11l1.2-6.77H497.32a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h14a.52.52,0,0,1,.39.17.51.51,0,0,1,.1.41l-1.37,7.78A.5.5,0,0,1,509.93,125.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.55,128.54h0l-11,0a.5.5,0,0,1-.49-.44L496.53,116h-3.09a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H497a.49.49,0,0,1,.5.43L499,127.5l10.54,0a.5.5,0,0,1,.5.5A.51.51,0,0,1,509.55,128.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.36,132.44a1.87,1.87,0,1,1,1.87-1.86A1.86,1.86,0,0,1,500.36,132.44Zm0-2.73a.87.87,0,1,0,.87.87A.86.86,0,0,0,500.36,129.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.94,132.44a1.87,1.87,0,1,1,1.86-1.86A1.87,1.87,0,0,1,507.94,132.44Zm0-2.73a.87.87,0,1,0,.86.87A.87.87,0,0,0,507.94,129.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502,125.82a.51.51,0,0,1-.5-.47l-.47-7.52a.5.5,0,0,1,.47-.53.49.49,0,0,1,.53.47l.47,7.52a.5.5,0,0,1-.47.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.18,125.82h0a.5.5,0,0,1-.47-.53l.42-7.52a.48.48,0,0,1,.52-.47.49.49,0,0,1,.47.52l-.42,7.53A.49.49,0,0,1,506.18,125.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.74,122.06a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5l12.87-.13a.51.51,0,0,1,.5.5.49.49,0,0,1-.49.5l-12.87.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.71,175.06a20.46,20.46,0,0,1-5.68-2l3.2-7.7a16.92,16.92,0,0,0,4.66,1.86,21.36,21.36,0,0,0,5.22.67,7.92,7.92,0,0,0,2.81-.34,1.09,1.09,0,0,0,.81-1c0-.45-.34-.76-1-.93a25,25,0,0,0-3.29-.52,44.3,44.3,0,0,1-5.89-1.06,9.21,9.21,0,0,1-4.26-2.51,7.23,7.23,0,0,1-1.84-5.32,7.88,7.88,0,0,1,1.66-4.92,11.14,11.14,0,0,1,4.93-3.46,21.59,21.59,0,0,1,7.89-1.29,33.58,33.58,0,0,1,6.28.59,19.06,19.06,0,0,1,5.24,1.74l-3.2,7.7a16.51,16.51,0,0,0-8.17-2.07c-2.55,0-3.82.45-3.82,1.34,0,.45.34.77,1,1a23.45,23.45,0,0,0,3.26.54,39.65,39.65,0,0,1,5.86,1.09,9.42,9.42,0,0,1,4.24,2.53,7.25,7.25,0,0,1,1.84,5.33,7.74,7.74,0,0,1-1.66,4.81,11.13,11.13,0,0,1-5,3.46,22.08,22.08,0,0,1-8,1.29A33.57,33.57,0,0,1,207.71,175.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,149.67c2.12,2.1,3.18,5.28,3.18,9.51v16.13H252.54V161.2q0-4.86-3.47-4.86a4.06,4.06,0,0,0-3.18,1.37,6.39,6.39,0,0,0-1.21,4.32v13.28H233V137h11.69v12.36a11.8,11.8,0,0,1,8-2.79A11.42,11.42,0,0,1,261,149.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.29,173.94a14.45,14.45,0,0,1-5.87-5.22,14.58,14.58,0,0,1,0-15.14,14.34,14.34,0,0,1,5.87-5.2,20.26,20.26,0,0,1,17,0,14.13,14.13,0,0,1,5.84,5.2,14.75,14.75,0,0,1,0,15.14,14.24,14.24,0,0,1-5.84,5.22,20,20,0,0,1-17,0Zm11.76-8.68a6,6,0,0,0,1.29-4.11,5.91,5.91,0,0,0-1.29-4.08,4.5,4.5,0,0,0-6.62,0,5.91,5.91,0,0,0-1.29,4.08,6,6,0,0,0,1.29,4.11,4.46,4.46,0,0,0,6.62,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.57,148.3a12.92,12.92,0,0,1,5,5.15,17.28,17.28,0,0,1,0,15.48,13,13,0,0,1-5,5.12,13.57,13.57,0,0,1-6.85,1.78c-3.13,0-5.53-.81-7.18-2.43v11.94H304.85V147H316v2.32q2.53-2.84,7.75-2.84A13.57,13.57,0,0,1,330.57,148.3Zm-6.33,17a5.91,5.91,0,0,0,1.29-4.08,6,6,0,0,0-1.29-4.11,4.46,4.46,0,0,0-6.62,0,6,6,0,0,0-1.29,4.11,5.91,5.91,0,0,0,1.29,4.08,4.5,4.5,0,0,0,6.62,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.51,163.83l-50.76,18a1.87,1.87,0,0,1-1.25-3.52l49.29-17.5-5.47-32.65L401.81,149.3a1.87,1.87,0,0,1-1.25-3.52l61.61-21.87a1.87,1.87,0,0,1,2.47,1.45l6.09,36.4A1.87,1.87,0,0,1,469.51,163.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.09,176.4h0l-48.41,17a1.87,1.87,0,0,1-2.28-.92l-25.93-51.19-14,5a1.87,1.87,0,1,1-1.25-3.52l15.53-5.51a1.86,1.86,0,0,1,2.29.91L424,189.33l46.86-16.45a1.87,1.87,0,0,1,1.25,3.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.73,208a8.25,8.25,0,1,1,5-10.53A8.24,8.24,0,0,1,437.73,208Zm-4.27-12a4.51,4.51,0,1,0,5.77,2.75A4.51,4.51,0,0,0,433.46,195.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.1,196.12a8.26,8.26,0,1,1,5-10.54A8.26,8.26,0,0,1,471.1,196.12Zm-4.27-12a4.52,4.52,0,1,0,5.77,2.75A4.51,4.51,0,0,0,466.83,184.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.43,176.28a1.87,1.87,0,0,1-2.35-1l-13.83-32.41a1.87,1.87,0,0,1,1-2.45,1.8,1.8,0,0,1,2.45,1l13.83,32.41a1.87,1.87,0,0,1-1,2.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,169.69l-.1,0a1.87,1.87,0,0,1-2.32-1.26l-9.91-33.8a1.79,1.79,0,0,1,1.26-2.32,1.87,1.87,0,0,1,2.32,1.27l9.92,33.8A1.87,1.87,0,0,1,453,169.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,166.31a1.87,1.87,0,0,1-1.26-3.52l56.5-20.68h0a1.87,1.87,0,0,1,1.27,3.51L410,166.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 480.54,
    y: 103.67,
    width: 147.28,
    height: 181.97,
    rx: 7.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.71,103.67h135a6.16,6.16,0,0,1,6.16,6.16V125a0,0,0,0,1,0,0H480.54a0,0,0,0,1,0,0V109.84A6.16,6.16,0,0,1,486.71,103.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.78,285.64l.42,0a5.6,5.6,0,0,0,1.22-.23,6,6,0,0,0,3.67-3,6.77,6.77,0,0,0,.56-1.59,9.62,9.62,0,0,0,.11-1.89c0-1.33,0-2.79,0-4.37,0-3.15,0-6.8,0-10.89,0-16.41-.05-40.14-.08-69.45,0-14.66,0-30.72,0-48q0-12.93,0-26.72,0-3.44,0-6.93c0-1.16,0-2.36,0-3.48a5.85,5.85,0,0,0-1.3-3.08,6,6,0,0,0-2.81-1.86,12.51,12.51,0,0,0-3.49-.24h-7.22l-126.12,0a5.92,5.92,0,0,0-3.7,1.33,5.82,5.82,0,0,0-2,3.37,10.38,10.38,0,0,0-.11,2v54.87c0,21.09,0,41.44,0,60.83,0,9.69,0,19.15,0,28.33v13.57c0,2.23,0,4.44,0,6.63v3.27a10.59,10.59,0,0,0,.26,3.16,5.87,5.87,0,0,0,4.35,4,16.82,16.82,0,0,0,3.11.13h15.38l23,0,69.44.08,18.88,0,4.91,0c1.11,0,1.68,0,1.68,0l-1.68,0-4.91,0-18.88,0-69.44.09H488.48a17.35,17.35,0,0,1-3.2-.13,6.33,6.33,0,0,1-4.67-4.27,10.51,10.51,0,0,1-.28-3.29c0-1.08,0-2.18,0-3.27v-6.63q0-6.67,0-13.57c0-9.18,0-18.64,0-28.33,0-19.39,0-39.74,0-60.83q0-15.83,0-32.18V110.66a11.05,11.05,0,0,1,.12-2.13,6.32,6.32,0,0,1,2.18-3.67,6.42,6.42,0,0,1,4-1.45l126.12,0h9a6.63,6.63,0,0,1,1.83.26,6.42,6.42,0,0,1,3,2A6.33,6.33,0,0,1,628,109c.08,1.22,0,2.35,0,3.53q0,3.5,0,6.93,0,13.78,0,26.72c0,17.24,0,33.3,0,48,0,29.31-.07,53-.08,69.45,0,4.09,0,7.74,0,10.89,0,1.58,0,3,0,4.37a9.89,9.89,0,0,1-.13,1.91,6.21,6.21,0,0,1-.58,1.62,6.07,6.07,0,0,1-3.75,3,5.16,5.16,0,0,1-1.23.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.54,114.34a3.42,3.42,0,1,1-3.42-3.42A3.42,3.42,0,0,1,495.54,114.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.38,114.34a3.42,3.42,0,1,1-3.41-3.42A3.41,3.41,0,0,1,505.38,114.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.23,114.34a3.42,3.42,0,1,1-3.42-3.42A3.42,3.42,0,0,1,515.23,114.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.55,
    y: 137.48,
    width: 40.55,
    height: 40.55,
    rx: 3.84,
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.59,161.09h-13.4a.38.38,0,0,1,0-.75h13.08l1.47-8.28H548.93a.38.38,0,0,1-.37-.38.37.37,0,0,1,.37-.37h16.26a.37.37,0,0,1,.28.13.36.36,0,0,1,.09.31l-1.6,9A.38.38,0,0,1,563.59,161.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.14,164.25h0l-12.75,0a.37.37,0,0,1-.37-.33l-1.83-14.23h-3.77a.38.38,0,0,1,0-.75h4.1a.37.37,0,0,1,.37.33l1.83,14.23,12.43,0a.38.38,0,0,1,.37.38A.37.37,0,0,1,563.14,164.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.47,168.79a2,2,0,1,1,2-2A2,2,0,0,1,552.47,168.79Zm0-3.17a1.21,1.21,0,1,0,1.21,1.21A1.21,1.21,0,0,0,552.47,165.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.27,168.79a2,2,0,1,1,2-2A2,2,0,0,1,561.27,168.79Zm0-3.17a1.21,1.21,0,1,0,1.22,1.21A1.21,1.21,0,0,0,561.27,165.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.33,161.09a.37.37,0,0,1-.37-.35l-.55-8.74a.38.38,0,0,1,.75-.05l.54,8.74a.37.37,0,0,1-.35.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.23,161.09h0a.38.38,0,0,1-.36-.39l.49-8.75a.37.37,0,0,1,.4-.35.38.38,0,0,1,.35.39l-.49,8.75A.37.37,0,0,1,559.23,161.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.43,156.72a.38.38,0,0,1,0-.75l15-.15h0a.38.38,0,0,1,.37.38.37.37,0,0,1-.37.37l-15,.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.02,
    cy: 150.21,
    r: 4.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.55,
    y: 189.88,
    width: 45.27,
    height: 6.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.2,
    y: 189.88,
    width: 17.62,
    height: 6.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.55,
    y: 202.72,
    width: 58.51,
    height: 6.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.2,
    y: 202.72,
    width: 17.62,
    height: 6.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.55,
    y: 215.56,
    width: 27.4,
    height: 6.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.2,
    y: 215.56,
    width: 17.62,
    height: 6.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.2,
    y: 227.78,
    width: 17.62,
    height: 6.05,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.61,
    y: 249.15,
    width: 51.73,
    height: 20.02,
    rx: 9.5,
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(564.42 152.31)",
    style: {
      fontSize: "5.630829811096191px",
      fill: "#17C1E8",
      fontFamily: "Montserrat-Bold, Montserrat",
      fontWeight: 700
    }
  }, "3")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Basket--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.26,399.45h-68.6c-1.77,0-3,1-2.64,2.19q4.05,15.78,8.09,31.56a3.17,3.17,0,0,0,3,2.19h51.76a3.17,3.17,0,0,0,3-2.19q4-15.78,8.09-31.56C335.21,400.43,334,399.45,332.26,399.45Zm-58.65,30.72c0,.17-.09.31-.21.31H272c-.12,0-.22-.14-.22-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.1-.3.22-.3h1.37c.12,0,.21.14.21.3ZM277,430.17c0,.17-.09.31-.22.31H275.4c-.12,0-.22-.14-.22-.31V419.78H277Zm0-12.26h-1.8v-10.4c0-.16.1-.3.22-.3h1.36c.13,0,.22.14.22.3Zm3.37,12.26c0,.17-.1.31-.22.31h-1.37c-.12,0-.21-.14-.21-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.09-.3.21-.3h1.37c.12,0,.22.14.22.3Zm6.73,12.26c0,.17-.1.31-.21.31h-1.38c-.11,0-.21-.14-.21-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.1-.3.21-.3h1.38c.11,0,.21.14.21.3Zm3.37,12.26c0,.17-.1.31-.22.31h-1.37c-.12,0-.21-.14-.21-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.09-.3.21-.3h1.37c.12,0,.22.14.22.3Zm3.36,12.26c0,.17-.1.31-.21.31h-1.37c-.12,0-.22-.14-.22-.31V419.78h1.8Zm0-12.26H292v-10.4c0-.16.1-.3.22-.3h1.37c.11,0,.21.14.21.3Zm3.37,12.26c0,.17-.1.31-.22.31h-1.37c-.12,0-.21-.14-.21-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.09-.3.21-.3H297c.12,0,.22.14.22.3Zm3.36,12.26c0,.17-.09.31-.21.31H299c-.12,0-.22-.14-.22-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.1-.3.22-.3h1.37c.12,0,.21.14.21.3Zm3.37,12.26c0,.17-.1.31-.22.31h-1.37c-.11,0-.21-.14-.21-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.1-.3.21-.3h1.37c.12,0,.22.14.22.3Zm3.37,12.26c0,.17-.1.31-.22.31h-1.37c-.12,0-.21-.14-.21-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.09-.3.21-.3h1.37c.12,0,.22.14.22.3Zm3.36,12.26c0,.17-.09.31-.21.31h-1.37c-.12,0-.22-.14-.22-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.1-.3.22-.3h1.37c.12,0,.21.14.21.3Zm6.74,12.26c0,.17-.1.31-.22.31h-1.37c-.12,0-.21-.14-.21-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.09-.3.21-.3h1.37c.12,0,.22.14.22.3Zm3.36,12.26c0,.17-.09.31-.21.31h-1.37c-.12,0-.22-.14-.22-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.1-.3.22-.3h1.37c.12,0,.21.14.21.3Zm3.37,12.26c0,.17-.1.31-.22.31h-1.37c-.12,0-.21-.14-.21-.31V419.78h1.8Zm0-12.26h-1.8v-10.4c0-.16.09-.3.21-.3h1.37c.12,0,.22.14.22.3Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.16,401.29a.94.94,0,0,1-.9,1h-80.6a1,1,0,0,1-.9-1v-3.58a1,1,0,0,1,.9-1h80.6a.94.94,0,0,1,.9,1Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.53,402.26c0,.13-17.58.23-39.26.23s-39.26-.1-39.26-.23,17.57-.23,39.26-.23S337.53,402.13,337.53,402.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.75,402.26a196.28,196.28,0,0,0,33.2,3c12.39.12,26.11-.51,38.19-3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.29,401.09h0A2,2,0,0,1,296.6,400l-12.22-28.83a2.07,2.07,0,0,1,1.1-2.7h0a2.06,2.06,0,0,1,2.69,1.09l12.21,28.84A2,2,0,0,1,299.29,401.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.44,
    cy: 399.18,
    r: 1.45,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bag-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.84,427.94a21.72,21.72,0,0,0-1-4.34,12.33,12.33,0,0,0-2.39-4,6.06,6.06,0,0,0-9.33,0,12.23,12.23,0,0,0-2.4,4,21.41,21.41,0,0,0-1.05,4.34,1.3,1.3,0,0,1,0-.32,7.86,7.86,0,0,1,.08-.9,15.2,15.2,0,0,1,.77-3.22,12.09,12.09,0,0,1,2.41-4.11,6.28,6.28,0,0,1,9.72,0A12.35,12.35,0,0,1,511,423.5a15.07,15.07,0,0,1,.76,3.22c.05.39.07.7.08.9A1.3,1.3,0,0,1,511.84,427.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.63,427.94a20.1,20.1,0,0,0-1-4.34,12.11,12.11,0,0,0-2.38-4,6.06,6.06,0,0,0-9.33,0,12.05,12.05,0,0,0-2.4,4,21.41,21.41,0,0,0-1.05,4.34,1.3,1.3,0,0,1,0-.32,7.86,7.86,0,0,1,.08-.9,14.6,14.6,0,0,1,.77-3.22,11.93,11.93,0,0,1,2.41-4.11,6.27,6.27,0,0,1,9.71,0,12.18,12.18,0,0,1,2.39,4.13,14.6,14.6,0,0,1,.77,3.22c.05.39.07.7.08.9A1.57,1.57,0,0,1,514.63,427.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.22 426.06 517.83 425.84 518.51 465.05 483.05 465.05 486.22 426.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "517.83 425.84 521.79 425.84 525.21 465.05 518.51 465.05 517.83 425.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "517.83 425.84 521.79 425.84 525.21 465.05 518.51 465.05 517.83 425.84"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 491.74,
    y: 439.16,
    width: 20.69,
    height: 3.96,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bags-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.78,397.57c-.05,0-.09-.58-.29-1.62a20.76,20.76,0,0,0-1.3-4.28,16.29,16.29,0,0,0-3.7-5.42A10.31,10.31,0,0,0,191,386.2a16.24,16.24,0,0,0-3.72,5.41,20.23,20.23,0,0,0-1.31,4.27c-.21,1-.25,1.63-.29,1.62a1.57,1.57,0,0,1,0-.43,12,12,0,0,1,.14-1.22,18.17,18.17,0,0,1,1.2-4.35,16.34,16.34,0,0,1,3.73-5.57,10.6,10.6,0,0,1,15,.05,16.24,16.24,0,0,1,3.71,5.58,18.72,18.72,0,0,1,1.19,4.36,11.36,11.36,0,0,1,.13,1.22A2,2,0,0,1,210.78,397.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.11,397.57s-.08-.58-.28-1.62a20.76,20.76,0,0,0-1.3-4.28,16.29,16.29,0,0,0-3.7-5.42,10.31,10.31,0,0,0-14.51-.05,16.24,16.24,0,0,0-3.72,5.41,19.65,19.65,0,0,0-1.31,4.27c-.21,1-.25,1.63-.3,1.62a2,2,0,0,1,0-.43,11.36,11.36,0,0,1,.13-1.22,18.77,18.77,0,0,1,1.21-4.35,16.05,16.05,0,0,1,3.73-5.57,10.6,10.6,0,0,1,15,.05,16.24,16.24,0,0,1,3.71,5.58,18.72,18.72,0,0,1,1.19,4.36c.08.53.11.94.13,1.22A1.57,1.57,0,0,1,215.11,397.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.24 396.02 222.23 395.65 223.3 462.42 168.33 462.42 173.24 396.02",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.23 395.65 228.38 395.65 233.67 462.42 223.3 462.42 222.23 395.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.78,
    y: 421.94,
    width: 32.07,
    height: 5.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.44,413.25a29.67,29.67,0,0,0-1.46-6.08,17,17,0,0,0-3.34-5.59,8.48,8.48,0,0,0-13.07-.05,17,17,0,0,0-3.36,5.57,29.89,29.89,0,0,0-1.48,6.08,2.44,2.44,0,0,1,0-.44c0-.29,0-.72.11-1.27a21.45,21.45,0,0,1,1.09-4.51,17,17,0,0,1,3.37-5.76,8.77,8.77,0,0,1,13.61.05,17.1,17.1,0,0,1,3.36,5.78,21.82,21.82,0,0,1,1.06,4.51c.07.55.1,1,.11,1.27A1.23,1.23,0,0,1,188.44,413.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.36,413.25a30,30,0,0,0-1.45-6.08,17,17,0,0,0-3.35-5.59,8.48,8.48,0,0,0-13.07-.05,17,17,0,0,0-3.36,5.57,29.89,29.89,0,0,0-1.48,6.08,2.44,2.44,0,0,1,0-.44c0-.29,0-.72.11-1.27a21.45,21.45,0,0,1,1.09-4.51,17,17,0,0,1,3.37-5.76,8.79,8.79,0,0,1,13.62.05,17.23,17.23,0,0,1,3.35,5.78,21.18,21.18,0,0,1,1.06,4.51c.07.55.1,1,.11,1.27A1.23,1.23,0,0,1,192.36,413.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.55 410.61 196.83 410.31 197.8 465.25 148.11 465.25 152.55 410.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.83 410.31 202.39 410.31 207.18 465.25 197.8 465.25 196.83 410.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.83 410.31 202.39 410.31 207.18 465.25 197.8 465.25 196.83 410.31"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 160.29,
    y: 428.97,
    width: 28.99,
    height: 5.55,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.81,323.37l-6.94-.41a22.35,22.35,0,1,1,4.79-6.42h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.81,323.37l-.13-.43-.39-1.31c-.36-1.16-.88-2.88-1.57-5.11l0-.1-.06.07h0l.09.07a22.33,22.33,0,0,0,2.36-10.73,21,21,0,0,0-.38-3.45,23.87,23.87,0,0,0-1-3.58,22.27,22.27,0,0,0-11.23-12.38,22.2,22.2,0,0,0-19.37-.1,21.89,21.89,0,0,0-8.3,6.76L350,294.2l-.71,1.18-.35.59-.3.62-.58,1.23c-.18.42-.32.85-.48,1.27a10.07,10.07,0,0,0-.42,1.28,18.31,18.31,0,0,0-.58,2.62A22.23,22.23,0,0,0,352,321.66a22.56,22.56,0,0,0,7.23,5.3,22.3,22.3,0,0,0,7.88,2,24.32,24.32,0,0,0,3.73,0,31.7,31.7,0,0,0,3.43-.62,22.33,22.33,0,0,0,9.6-5.29h0l5.18.27,1.32.06.44,0-.46,0-1.34-.09-5.14-.33h0a22.24,22.24,0,0,1-9.57,5.21,28.78,28.78,0,0,1-3.39.6,25.29,25.29,0,0,1-3.7,0,22.07,22.07,0,0,1-7.8-2A22.09,22.09,0,0,1,346.79,303a20.85,20.85,0,0,1,.57-2.58,11.11,11.11,0,0,1,.42-1.27c.16-.41.3-.84.47-1.25l.58-1.22.3-.61.35-.58c.23-.39.46-.78.7-1.17s.53-.73.8-1.1a21.76,21.76,0,0,1,8.21-6.68,22,22,0,0,1,9.88-2.15,22.39,22.39,0,0,1,9.27,2.23,22.12,22.12,0,0,1,11.14,12.23,23.2,23.2,0,0,1,1,3.55,21.91,21.91,0,0,1,.4,3.42,22.48,22.48,0,0,1-2.29,10.67l-.19.37.28-.31h0l-.1,0,1.62,5.06.43,1.31C390.75,323.22,390.81,323.37,390.81,323.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.12,309.42H363.9a.43.43,0,0,1,0-.85h11.87l1.31-7.39H362.75a.43.43,0,0,1,0-.85h14.83a.41.41,0,0,1,.33.15.44.44,0,0,1,.09.35l-1.46,8.24A.42.42,0,0,1,376.12,309.42Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.72,312.31h0l-11.64,0a.42.42,0,0,1-.42-.37L362,299h-3.37a.43.43,0,0,1,0-.85h3.74a.41.41,0,0,1,.42.37l1.66,12.92,11.27,0a.43.43,0,0,1,0,.85Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,316.45a1.88,1.88,0,1,1,1.87-1.87A1.88,1.88,0,0,1,366,316.45Zm0-2.9a1,1,0,1,0,1,1A1,1,0,0,0,366,313.55Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,316.45a1.88,1.88,0,1,1,1.88-1.87A1.87,1.87,0,0,1,374,316.45Zm0-2.9a1,1,0,1,0,1,1A1,1,0,0,0,374,313.55Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.67,309.42a.43.43,0,0,1-.42-.4l-.5-8a.43.43,0,0,1,.4-.45.4.4,0,0,1,.45.39l.5,8a.43.43,0,0,1-.4.45Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.14,309.42h0a.43.43,0,0,1-.4-.45l.45-8a.4.4,0,0,1,.44-.39.41.41,0,0,1,.4.44l-.44,8A.43.43,0,0,1,372.14,309.42Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.2,305.43a.43.43,0,0,1,0-.85l13.65-.13h0a.43.43,0,0,1,0,.85l-13.65.13Z",
    style: {
      fill: "#17C1E8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.12,140.58l-6.94-.4A22.39,22.39,0,1,1,82,133.76h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.12,140.58l-.13-.43-.39-1.3c-.36-1.17-.88-2.89-1.56-5.12l0-.1-.07.08h0l.1.06a22.41,22.41,0,0,0,2.36-10.72,21,21,0,0,0-.39-3.45A24.69,24.69,0,0,0,83,116a22.17,22.17,0,0,0-4.13-7,22.56,22.56,0,0,0-16.47-7.67,22.48,22.48,0,0,0-18.31,8.92c-.27.37-.55.74-.81,1.12s-.48.78-.71,1.18l-.36.59-.29.61c-.2.41-.39.83-.59,1.24s-.32.84-.48,1.27a11.27,11.27,0,0,0-.42,1.28,21.35,21.35,0,0,0-.58,2.61,22.16,22.16,0,0,0,5.52,18.67,22.56,22.56,0,0,0,7.23,5.3,22.26,22.26,0,0,0,7.88,2,24.31,24.31,0,0,0,3.73-.05,27,27,0,0,0,3.42-.62,22.17,22.17,0,0,0,9.6-5.29h0l5.18.27,1.32.07h.44l-.46,0-1.33-.09-5.14-.34h0l0,0a22.19,22.19,0,0,1-9.56,5.2,29,29,0,0,1-3.4.6,23.94,23.94,0,0,1-3.7,0,22.3,22.3,0,0,1-19.7-15.59,22.6,22.6,0,0,1-.68-10.15,21.3,21.3,0,0,1,.58-2.58,9.8,9.8,0,0,1,.42-1.26c.15-.42.29-.85.47-1.26s.38-.81.58-1.22l.29-.61.35-.58.7-1.16c.26-.38.54-.74.81-1.11a21.73,21.73,0,0,1,8.2-6.68,22.09,22.09,0,0,1,19.15.08A22.06,22.06,0,0,1,82.8,116.1a26,26,0,0,1,1,3.54,23.13,23.13,0,0,1,.39,3.42,22.33,22.33,0,0,1-2.29,10.67l-.18.38.28-.32h0l-.1,0c.7,2.21,1.25,3.91,1.62,5.06.18.58.32,1,.42,1.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.43,120.74A5.41,5.41,0,0,0,68.87,118a5.08,5.08,0,0,0-2.77-1.45,4.13,4.13,0,0,0-4.39,2.42,4.12,4.12,0,0,0-1.32-1.24,4.22,4.22,0,0,0-3.26-.41,5.12,5.12,0,0,0-2.55,1.82,5.33,5.33,0,0,0-1.17,3A6.47,6.47,0,0,0,54.49,126a9.19,9.19,0,0,0,3.35,2.73c2.14,1.1,5,2.47,5,2.47S65,129.32,67,127.94a9.23,9.23,0,0,0,3-3.17A6.42,6.42,0,0,0,70.43,120.74Z",
    style: {
      fill: "#17C1E8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "692.4 267.66 739.21 311.44 729.4 322.08 687.6 273.17 692.4 267.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "729.4 322.08 697.79 326.01 672.85 279.61 687.6 273.17 729.4 322.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.4,322.08a17,17,0,0,1-.62-2.89c-.32-1.79-.73-4.29-1.16-7.08l0-.29h.29l.6,0c3-.16,5.64-.28,7.59-.34a19.21,19.21,0,0,1,3.15,0,18.57,18.57,0,0,1-3.13.36c-1.94.15-4.62.33-7.58.49l-.61,0,.25-.3c.42,2.79.77,5.3,1,7.11A16.32,16.32,0,0,1,729.4,322.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.07,270.31c.11-.09,8.66,9.18,19.1,20.7s18.82,21,18.71,21.06-8.66-9.17-19.1-20.71S690,270.41,690.07,270.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "729.4 322.08 697.79 326.01 672.85 279.61 687.6 273.17 729.4 322.08"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "727.44 329.32 712.96 341.66 687.44 279 688.68 278.24 727.44 329.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712.96 341.66 689.87 335.97 672.41 282.34 687.44 279 712.96 341.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "712.96 341.66 689.87 335.97 672.41 282.34 687.44 279 712.96 341.66"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M713,341.66a3.32,3.32,0,0,1,.11-1c.11-.65.29-1.58.51-2.73.45-2.3,1.11-5.47,1.87-9,.12-.54.23-1.07.34-1.57l.06-.24.24,0c3.15.56,5.94,1.08,7.94,1.47a21.13,21.13,0,0,1,3.19.74A22.83,22.83,0,0,1,724,329c-2-.3-4.81-.76-8-1.3l.3-.2c-.11.5-.22,1-.34,1.57-.76,3.49-1.48,6.65-2,8.93-.27,1.14-.5,2.06-.67,2.69A4.34,4.34,0,0,1,713,341.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688,278.75c.12-.07,6.5,10.77,14.23,24.22s13.91,24.4,13.79,24.48-6.5-10.77-14.24-24.22S687.9,278.82,688,278.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "682.55 277.59 702.74 324.37 686.2 330.1 681.23 277.87 682.55 277.59",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "686.2 330.1 670.86 326.63 668.76 279.52 681.23 277.87 686.2 330.1",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "686.2 330.1 670.86 326.63 668.76 279.52 681.23 277.87 686.2 330.1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M686.2,330.1a17.57,17.57,0,0,1,1.85-2.5c1.19-1.5,2.87-3.55,4.75-5.8l.61-.73.11-.14.17.06c2.56.88,4.84,1.7,6.46,2.3a16.91,16.91,0,0,1,2.59,1.07,15,15,0,0,1-2.7-.73c-1.66-.52-3.95-1.28-6.51-2.15l.28-.08-.61.73c-1.88,2.25-3.6,4.27-4.87,5.71A18.85,18.85,0,0,1,686.2,330.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.9,277.73c.14,0,2.88,9.67,6.11,21.68s5.74,21.79,5.6,21.83-2.87-9.68-6.11-21.69S681.77,277.76,681.9,277.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "692.4 267.66 675.47 275.43 677.17 277.73 687.6 273.17 692.4 267.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "688.68 278.24 683.32 279.38 683.56 279.87 687.44 279 688.68 278.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683,211.41s5.68,7.33,6.29,12c.51,3.84,3.28,24.65,4.7,34.45a14.47,14.47,0,0,1-3,11.26c-2.45,3-6.15,5-11.15,1.54-3.44-2.41-12.24-12.25-12.24-12.25l14.47-45.34",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.36,148.62a11.1,11.1,0,0,0-8.52.88,6.57,6.57,0,0,0-11.34,1.74,5.56,5.56,0,0,0-5.58,9.47,7.15,7.15,0,0,0-3,10.86c-2.13,1-2.5,3.94-2.19,6.29s1,4.88-.06,7c-.81,1.65-2.5,2.67-3.65,4.1s-1.55,3.89,0,4.86a5,5,0,1,0,1.79,9.76,6.09,6.09,0,0,0,.65,5.84,9.76,9.76,0,0,0,4.89,3.56,14.58,14.58,0,0,0,15.94-4.49l17.58-54.35A11.08,11.08,0,0,0,667.36,148.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.72,163.68l.23-2.93-17.43-4.42c-5.4-.9-11.61,4.2-12.28,9.63-.75,6-1.42,13.44-1,18,.89,9.18,7.79,10.76,7.79,10.76l-.5,9,20.1,1.46Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.37,174.62a1.17,1.17,0,0,0,1.06,1.25,1.12,1.12,0,0,0,1.26-1,1.17,1.17,0,0,0-1.05-1.25A1.13,1.13,0,0,0,648.37,174.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.93,169.94c.14.16,1.06-.44,2.31-.36s2.14.76,2.29.62-.06-.35-.45-.67a3.18,3.18,0,0,0-1.81-.68,3.09,3.09,0,0,0-1.85.48C648,169.6,647.86,169.87,647.93,169.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.38,175.3a1.17,1.17,0,0,0,1,1.25,1.13,1.13,0,0,0,1.27-1,1.18,1.18,0,0,0-1.06-1.25A1.12,1.12,0,0,0,659.38,175.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.25,170.92c.14.16,1.06-.44,2.32-.36s2.13.76,2.28.61-.06-.34-.44-.66a3.17,3.17,0,0,0-1.82-.68,3,3,0,0,0-1.85.47C660.34,170.58,660.19,170.84,660.25,170.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.14,180a8.5,8.5,0,0,0-2-.49c-.32-.05-.62-.13-.66-.36a1.69,1.69,0,0,1,.27-.93c.35-.76.72-1.55,1.1-2.39a42,42,0,0,0,2.51-6.25,42.16,42.16,0,0,0-3,6q-.55,1.25-1.05,2.4a1.82,1.82,0,0,0-.25,1.24.84.84,0,0,0,.5.51,2.61,2.61,0,0,0,.54.1A8.08,8.08,0,0,0,655.14,180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.07,194.75a24.11,24.11,0,0,0,12.68-2.52s-3.45,6.19-12.81,4.79Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.54,166.59c.13.34,1.38.17,2.86.35s2.67.58,2.86.28c.09-.15-.12-.47-.6-.8a4.94,4.94,0,0,0-4.36-.48C660.76,166.15,660.49,166.42,660.54,166.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.23,166.83c.21.3,1.09.07,2.13.12s1.91.33,2.13,0c.1-.13,0-.43-.39-.73a3,3,0,0,0-1.69-.58,2.94,2.94,0,0,0-1.73.45C648.29,166.4,648.15,166.69,648.23,166.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.28,159.42a15.26,15.26,0,0,1,8.3-5.48l14.72,1.85,1.26,0c.27-.93,1.84-1.41,1.84-1.41,1.38-1.07,6.17-1.12,9.51,2.37,1.21,1.26,2.06,4.43,2.09,6.17,0,.66-.69,1.56-.14,1.93a18.65,18.65,0,0,0,2,.14c3.74.82,6.08,4.14,5.4,9.1a2.78,2.78,0,0,0-.08.75,2.09,2.09,0,0,0,.66,1,6.49,6.49,0,0,1,1,7.23,8,8,0,0,0-1,2.17c-.23,1.42.81,2.68,1.61,3.87,2.4,3.57,2.92,8.75.1,12a6.8,6.8,0,0,0-1.83,2.5,6.52,6.52,0,0,0-.08,1.53c0,2.59-1.35,5.49-3.88,6-1.41.3-3.11-.1-4.11.94a6.07,6.07,0,0,0-.9,1.64,5.25,5.25,0,0,1-6.06,2.6c-2.28-.7-3-10-2.71-12.34-2.76-1-4.81-1.18-4.68-4.12,0,0,.42-5.07-.4-7.53s.83-7.72,1.77-10.27-.18-8.48-.43-10.84a8.11,8.11,0,0,1,.19-2h0c.1-.58.24-1.22.4-1.91s.59-4.09.58-4.69c0-2.24-2.81-1-4.92-.33a5.37,5.37,0,0,1-1.59.28,5.64,5.64,0,0,1-4.55-2.15,8.1,8.1,0,0,1-8,2.19,21.86,21.86,0,0,1-3.81,4.43,7.45,7.45,0,0,1-5.39,1.85A15.24,15.24,0,0,1,646.28,159.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.05,183a2.23,2.23,0,0,1,1.94-.92,2,2,0,0,1,1.44.68,1.27,1.27,0,0,1,.17,1.46,1.47,1.47,0,0,1-1.59.49,4.69,4.69,0,0,1-1.62-.86,1.34,1.34,0,0,1-.37-.34.41.41,0,0,1,0-.46",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,180.72c-.2,0-.13,1.34-1.23,2.34s-2.52.93-2.53,1.12.33.25.94.23a3.31,3.31,0,0,0,2.11-.86,2.88,2.88,0,0,0,.95-2C659.3,181,659.13,180.71,659,180.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.1,420.28l1.66,17.26s-18.81,7-19,10.5l35.56.1,0-2.6-1.49-8.88-2.2-17.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.47,434.86a1.49,1.49,0,0,1,1,1.69,1.42,1.42,0,0,1-1.67,1,1.57,1.57,0,0,1-1.09-1.8,1.48,1.48,0,0,1,1.86-.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.31,448.14l0-2.6-34.11.65s-1.62.71-1.43,1.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.17,437.35c0,.18.9.26,1.77.83s1.34,1.31,1.51,1.24-.11-1.09-1.18-1.76S632.13,437.19,632.17,437.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.36,438.94c0,.18.73.48,1.33,1.23s.78,1.54,1,1.53.29-1-.48-1.93S628.36,438.77,628.36,438.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.2,443.52c.16,0,.41-.85-.05-1.83s-1.29-1.35-1.37-1.21.44.67.81,1.48S626,443.5,626.2,443.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.91,433.2c.07.17.89-.08,1.89,0s1.79.38,1.88.22-.66-.78-1.84-.84S630.82,433.07,630.91,433.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.81,420.77l1.52,17s-18.52,6.79-18.74,10.21l34.93.31v-2.56L691.11,437,689.05,420Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.86,435.17a1.47,1.47,0,0,1,1,1.67,1.42,1.42,0,0,1-1.65,1,1.54,1.54,0,0,1-1.05-1.78,1.45,1.45,0,0,1,1.82-.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.52,448.25v-2.56l-33.52.44s-1.59.69-1.41,1.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.75,437.55c0,.17.88.26,1.73.82s1.32,1.3,1.48,1.23-.1-1.08-1.15-1.74S675.71,437.39,675.75,437.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672,439.09c0,.16.72.46,1.31,1.21s.76,1.52.93,1.51.29-1-.46-1.9S672,438.92,672,439.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.85,443.57c.16,0,.4-.84,0-1.8s-1.26-1.34-1.34-1.19.43.66.79,1.45S669.68,443.55,669.85,443.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.54,433.46c.07.16.87-.07,1.86,0s1.75.38,1.84.23-.64-.77-1.81-.84S674.45,433.33,674.54,433.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.34,270.2s-8.43,24.41-8.72,42.57-.59,47,3.19,78.9,5.53,44.65,5.53,44.65h19.18a376.33,376.33,0,0,0,1.74-37.81c-.29-17.86-1.68-23.52,0-43.17s4.43-31.45,7.29-37.4c0,0,7.92-9.42,8.5-22.33a63,63,0,0,0-4-24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.38,304.45c.32,1,6,41,10.17,58.65s8.77,22.33,9.58,36.69c.93,16.52,5.47,36.53,5.47,36.53H693s-2.88-30.53-5.75-54.39-7-53.29-6.38-62.12,2.23-19.73,0-32.09-7.07-15.63-7.07-15.63l-17.33-.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.61,281.55a6.46,6.46,0,0,1,.32.62,12.2,12.2,0,0,1,.69,1.88,24.74,24.74,0,0,1,.67,7.32,47.89,47.89,0,0,1-1.68,10.77,34.08,34.08,0,0,1-2.23,6.06,41.77,41.77,0,0,1-3.69,5.86c-2.77,3.82-4.14,8.18-5.18,12.11a86.77,86.77,0,0,0-1.94,10.68c-.38,3.07-.6,5.57-.77,7.3-.09.83-.15,1.49-.2,2a5,5,0,0,1-.1.69,3.71,3.71,0,0,1,0-.7c0-.49.07-1.15.12-2,.12-1.73.3-4.23.64-7.31a81.32,81.32,0,0,1,1.86-10.74,49.91,49.91,0,0,1,1.93-6.16,30.81,30.81,0,0,1,1.42-3.11c.56-1,1.19-2,1.86-3A41.88,41.88,0,0,0,664,308a34.2,34.2,0,0,0,2.22-6A48.88,48.88,0,0,0,668,291.36a25.89,25.89,0,0,0-.53-7.26,15.77,15.77,0,0,0-.61-1.89A4.38,4.38,0,0,1,666.61,281.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.4,220.35a58.33,58.33,0,0,0,9.88,4.07l7.13-5.7s-5.1-9.32-6.74-12a14.44,14.44,0,0,1-1.33-2.82c-.55-2-2-1.14-2.28.42a8.72,8.72,0,0,0,.45,2.52,7.33,7.33,0,0,1,.5,3s-.52-.44-1.81-1.31-6.11-4.87-8.11-6.52c-3-2.46-4.48-.93-4.09,0,.48,1.18,7.88,6.36,7.61,7.24,0,0-1.42.81-1.62,1.74a4.72,4.72,0,0,0,0,1.83s-1.33.13-1.69,1a3.38,3.38,0,0,0,.1,2.06s-1.23.11-1.38.79S582.75,218.76,585.4,220.35Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.23,216.16c.1.32,15.29,15.87,15.29,15.87s12.67-14.27,16.53-19.52,9.71-11.7,14.74-12.9,12,2,12,2L650.91,220l-11.26,15.49s-12.17,15.28-18,17.64-11.46-1-13.92-3.6-17.09-24.8-17.09-24.8Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.83,205.66l-34.94-6s-9.71,17.08-13.34,35-7.76,35.88-7.76,35.88l32.28,4a36.81,36.81,0,0,0,10.11-.14l3.36-.51-2.76-11.39a229.92,229.92,0,0,0,10-29.49C687.09,215.33,685.83,205.66,685.83,205.66Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.08,222.73a4.45,4.45,0,0,1-.57.77l-1.64,2c-1.39,1.69-3.26,4.05-5.34,6.66s-4,5-5.44,6.59c-.72.83-1.32,1.48-1.75,1.92a3.83,3.83,0,0,1-.69.65,4,4,0,0,1,.57-.76l1.64-2c1.38-1.69,3.26-4.05,5.34-6.66s4-5,5.44-6.59c.72-.83,1.32-1.48,1.74-1.92A4,4,0,0,1,650.08,222.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.24,263a9.28,9.28,0,0,1-2.19.63,31.91,31.91,0,0,1-5.46.67,32.87,32.87,0,0,1-5.5-.25,9.4,9.4,0,0,1-2.24-.46,16.63,16.63,0,0,1,2.27.16,45.1,45.1,0,0,0,5.45.13,45.78,45.78,0,0,0,5.43-.55A15.42,15.42,0,0,1,672.24,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.18,241.29a22.43,22.43,0,0,1-.15-4.43,23.81,23.81,0,0,1,.27-4.42,22.49,22.49,0,0,1,.15,4.43A22.82,22.82,0,0,1,616.18,241.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M684.71,209.63l-21.84-1.95a3.65,3.65,0,0,0,2.31,4.76A7.07,7.07,0,0,0,670.79,223a6.69,6.69,0,0,1,1.74.22c1.21.43,1.79,1.76,2.52,2.82a6.65,6.65,0,0,0,4.07,2.83,4.83,4.83,0,0,0,4.59-1.53,8,8,0,0,0,1.34-4.78A85.65,85.65,0,0,0,684.71,209.63Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M636.23,239.78A15.44,15.44,0,0,0,648.58,224C644,229,640.15,235.31,636.23,239.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M689.72,196.17l-18.63-20.73c.68,5.26-1.3,10.49-3.68,15.23-1.36,2.7-2.87,5.91-1.45,8.58a17.82,17.82,0,0,0-3.08,4.2,6,6,0,0,0-.2,5.05,3.65,3.65,0,0,0,4.34,2,5.68,5.68,0,0,0,7.84,7.05,9,9,0,0,0,3.49,5.43,6,6,0,0,0,6.24.41,4.53,4.53,0,0,0,1.84-5.7c4.1-.9,6.66-5.32,6.78-9.52S691.57,199.94,689.72,196.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.19,162a1.41,1.41,0,0,1-.31.12,2.63,2.63,0,0,1-1,.06,3.76,3.76,0,0,1-2.82-1.94,3.62,3.62,0,0,1-.39-2.4,4.94,4.94,0,0,1,1.28-2.49,5.28,5.28,0,0,1,2.68-1.53,7.08,7.08,0,0,1,3.3,0,9.23,9.23,0,0,1,1.81.65l-.28.11a7.62,7.62,0,0,1,3.9-4,7.37,7.37,0,0,1,7.26.76,5.41,5.41,0,0,1,.63.52c.13.13.19.21.18.22s-.31-.24-.89-.62a7.78,7.78,0,0,0-2.74-1.07,7,7,0,0,0-4.28.54,7.32,7.32,0,0,0-3.67,3.83l-.09.21-.2-.09a8.65,8.65,0,0,0-1.73-.62,7,7,0,0,0-3.11,0,4.93,4.93,0,0,0-2.49,1.4,4.59,4.59,0,0,0-1.21,2.28,3.3,3.3,0,0,0,.31,2.2A3.62,3.62,0,0,0,650,162,4.86,4.86,0,0,0,651.19,162Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.69,175s.16-.39.36-1.1a7.45,7.45,0,0,0,.16-3.11,6.72,6.72,0,0,0-2.18-4,7.09,7.09,0,0,0-5.34-1.74l-.31,0,.09-.3a8.47,8.47,0,0,0,.32-1.91,8.71,8.71,0,0,0-2-6,8.36,8.36,0,0,0-4.49-2.68,8.83,8.83,0,0,0-3.58-.11c-.84.15-1.29.32-1.3.29s.1-.07.31-.16a6.06,6.06,0,0,1,1-.29,8.73,8.73,0,0,1,8.39,2.7,9,9,0,0,1,2.15,6.28,8.21,8.21,0,0,1-.34,2l-.22-.27a7.39,7.39,0,0,1,5.63,1.88,7.1,7.1,0,0,1,1.91,7.45,4.4,4.4,0,0,1-.34.8A.92.92,0,0,1,690.69,175Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.9,210.54a1,1,0,0,1-.26-.16,6.12,6.12,0,0,1-.66-.57,7.67,7.67,0,0,1-1.88-7.46,7.84,7.84,0,0,1,3.66-4.49,7.35,7.35,0,0,1,2.29-.83l-.12.34a5.92,5.92,0,0,1-1.42-4.74,5.66,5.66,0,0,1,4.31-4.66,3.45,3.45,0,0,1,.71-.1c.16,0,.25,0,.25,0s-.34.06-.92.23a6,6,0,0,0-2.22,1.26,5.36,5.36,0,0,0-1.77,3.31,5.63,5.63,0,0,0,1.37,4.41l.25.28-.37.07a6.92,6.92,0,0,0-2.15.79,7.54,7.54,0,0,0-3.5,4.24,7.37,7.37,0,0,0,.08,4.53,7.76,7.76,0,0,0,1.55,2.69C672.59,210.25,672.92,210.5,672.9,210.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.59,164.91l-.58-2.63a19.19,19.19,0,0,0-1.87,12.34c.36,1.94,1,4,.16,5.8-.57,1.22-1.74,2.05-2.42,3.22-.85,1.47-.22,5.36-.44,6.12-.5,1.75-2.18,2.86-2.58,5s.11,4.65,2,5.66c3.56-5.87,7.2-12,8-18.79C675.59,176,674.31,170.3,672.59,164.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.39,179a.94.94,0,0,1-.31,0,4.7,4.7,0,0,1-.86-.09,5.91,5.91,0,0,1-2.92-1.31,4.43,4.43,0,0,1-1.27-1.85,3.47,3.47,0,0,1,0-2.59,3.16,3.16,0,0,1,2.2-1.83,2.34,2.34,0,0,1,1.57.22,1.47,1.47,0,0,1,.76,1.48,1.2,1.2,0,0,1-.48.77,1.56,1.56,0,0,1-.82.26,3.13,3.13,0,0,1-1.52-.36,7.33,7.33,0,0,1-2.22-1.76,7.22,7.22,0,0,1-1.77-4.39,7.13,7.13,0,0,1,.57-3.15,5.17,5.17,0,0,1,.4-.77q.16-.25.18-.24s-.18.37-.43,1.07a7.54,7.54,0,0,0-.42,3.07,7.09,7.09,0,0,0,1.76,4.15,7,7,0,0,0,2.12,1.65,2.72,2.72,0,0,0,1.31.31.86.86,0,0,0,.9-.68,1,1,0,0,0-.55-1,1.89,1.89,0,0,0-1.28-.18,2.77,2.77,0,0,0-1.92,1.58,3.09,3.09,0,0,0-.07,2.31,4.27,4.27,0,0,0,1.14,1.75,6,6,0,0,0,2.75,1.37C683,178.92,683.39,179,683.39,179Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.88,273.19a4.92,4.92,0,0,1-.26-.8l-.62-2.3c-.53-2.07-1.25-4.89-2.1-8.25v-.06l0-.06c1-3.36,2.37-7.3,3.89-11.48,2.25-6.19,4.42-11.75,6-15.76.78-1.94,1.43-3.54,1.92-4.73.21-.51.39-.93.54-1.28s.21-.44.23-.43a2.53,2.53,0,0,1-.13.47c-.12.35-.27.79-.46,1.31-.44,1.21-1,2.83-1.76,4.8-1.51,4-3.63,9.61-5.87,15.8-1.52,4.17-2.87,8.1-4,11.44v-.12c.78,3.37,1.43,6.2,1.91,8.28.2,1,.37,1.73.5,2.33A3.25,3.25,0,0,1,674.88,273.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.16,257.19c.09,0-.07,1.3-.08,3.38a50.17,50.17,0,0,0,.57,8.1,28.05,28.05,0,0,0,2.19,7.76,21.5,21.5,0,0,0,1.78,2.83,3.73,3.73,0,0,1-.69-.61,9.91,9.91,0,0,1-1.42-2.06,24.84,24.84,0,0,1-2.38-7.85,40.8,40.8,0,0,1-.42-8.18,23.86,23.86,0,0,1,.24-2.48A3.33,3.33,0,0,1,680.16,257.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.26,256.75s-.13.28-.4.75a12.82,12.82,0,0,0-.76,2.16,35.57,35.57,0,0,0-1,7.53,38.9,38.9,0,0,0,.44,7.59c.32,1.93.77,3.06.68,3.09a3.18,3.18,0,0,1-.38-.77,6.43,6.43,0,0,1-.33-1,12.88,12.88,0,0,1-.33-1.3,32,32,0,0,1-.6-7.68,29.48,29.48,0,0,1,1.13-7.62,9,9,0,0,1,.94-2.15C680,256.94,680.24,256.73,680.26,256.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.72,257.7a26.73,26.73,0,0,1-2.35-4.7,25.94,25.94,0,0,1-1.87-4.9,26.88,26.88,0,0,1,2.34,4.69A26.37,26.37,0,0,1,680.72,257.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.87,451.74l16.6,8.87s-4.94,21.22-1.92,23.49L464,452l-2.36-1.54-8.92-4-16.91-8.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.48,449.32a1.62,1.62,0,0,1,2.15.08,1.55,1.55,0,0,1-.07,2.14,1.7,1.7,0,0,1-2.27-.1,1.6,1.6,0,0,1,.31-2.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,452l-2.36-1.54L441.74,481.7s-.33,1.89.81,2.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,461c.16.1.77-.66,1.81-1.11s2-.42,2-.61-1.05-.57-2.3,0S443.78,461,444,461Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.1,465.43c.13.14.86-.38,1.9-.47s1.87.22,2,.05-.74-.87-2-.72S443,465.33,443.1,465.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.94,470.13c.13-.13-.53-.88-1.68-1.05s-2,.35-1.92.51.87,0,1.82.15S445.81,470.28,445.94,470.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.44,459.68c.19,0,.46-.86,1.12-1.73s1.42-1.38,1.34-1.56-1.11.13-1.88,1.16S439.26,459.67,439.44,459.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.25,433.2l-20.71,12.64-19.27,5.28c-2,.44-3,1.37-3,2.6a2.28,2.28,0,0,0,1.92,2.06L390,461.27a1,1,0,0,0,.74-.15c2.95-1.91,18.79-11.55,18.79-11.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.61,443.87a2.21,2.21,0,0,1,.78-.48,6.3,6.3,0,0,1,2.44-.58,2.86,2.86,0,0,1,1.78.37,1,1,0,0,1,.37,1.09,1.68,1.68,0,0,1-.75.88,3.53,3.53,0,0,1-4.36-1,4.07,4.07,0,0,1-.16-4.54,1.39,1.39,0,0,1,1-.64,1,1,0,0,1,1,.62,3.51,3.51,0,0,1,.09,1.8,7.41,7.41,0,0,1-.8,2.38,2.16,2.16,0,0,1-.54.74,11.31,11.31,0,0,0,1-3.16,3.2,3.2,0,0,0-.11-1.57.53.53,0,0,0-.52-.35,1,1,0,0,0-.62.47,3.65,3.65,0,0,0,.18,3.93,3.07,3.07,0,0,0,3.69.93,1.17,1.17,0,0,0,.55-.6.53.53,0,0,0-.19-.6,2.56,2.56,0,0,0-1.5-.34A9.64,9.64,0,0,0,390.61,443.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.28,453.72l32.72,6.6-1.16.69a2.57,2.57,0,0,1-1.82.31l-28.25-5.62a1.73,1.73,0,0,1-1.36-1.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.91,449.82c-.16,0-.28-.94-.74-2s-1-1.81-.92-1.92.91.55,1.4,1.71A2.89,2.89,0,0,1,382.91,449.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,451c-.13,0-.19-.89-.61-1.91s-.92-1.71-.84-1.81.92.5,1.33,1.63S378.19,451,378,451Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.85,452.12c-.15,0-.2-.91-.55-1.92s-.83-1.77-.71-1.87.83.57,1.21,1.7S374,452.13,373.85,452.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.35,445.51s.2-.27.73-.53a3.59,3.59,0,0,1,2.44-.26l.15,0v.16a1.37,1.37,0,0,1-1.27,1.06c-.56.08-1.13.1-1.74.15-.32,0-.61.06-1,0a1.45,1.45,0,0,1-1.05-.42,2.39,2.39,0,0,1-.49-1,8.13,8.13,0,0,1-.3-3.2,4.18,4.18,0,0,1,.22-1.06,1.07,1.07,0,0,1,.4-.48.79.79,0,0,1,.65-.08,1.22,1.22,0,0,1,.76.78,4.16,4.16,0,0,1,.23.87,5.8,5.8,0,0,1,.07,1.59,5.92,5.92,0,0,1-.63,2.2,2,2,0,0,1-.49.68,8.53,8.53,0,0,0,.75-2.9,6,6,0,0,0-.12-1.49c-.12-.5-.26-1.17-.7-1.27s-.59.54-.63,1.21a8.19,8.19,0,0,0,.07,2,4.07,4.07,0,0,0,.59,1.77c.31.38,1,.27,1.6.25s1.18,0,1.7-.1.91-.32,1-.67l.14.2a3.76,3.76,0,0,0-2.26.09C385.64,445.36,385.38,445.54,385.35,445.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,451.18a1.21,1.21,0,0,0-.49-.6.7.7,0,0,0-.75,0l-.1,0a1.43,1.43,0,0,0-.84,1.1,1.28,1.28,0,0,0,.57,1.24,1.17,1.17,0,0,0,1.34-.09A1.44,1.44,0,0,0,391.44,451.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.58,415.22s-49.1-29.33-60.93-15.42,9,28.85,13.08,31.67S427.07,454,427.07,454l8.51-16.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.5,439.23s60.65-32.62,67.31-35.83c5.72-2.76,21.81-11.43,27,5.72s-26,38.31-26,38.31l-12.92-6.72-17.85,8.44-22.27,10.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.75,458.47c-.58-.35-24.16-11.59-24.16-11.59l24.7-10.49,14,8.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.79,433.2l-.26.15-.8.4-3.11,1.51L442,440.86l-40.08,19.05-.19.08-.12-.16-12.69-17-2.6-3.48-.18-.24.27-.14c19.3-10.51,36.65-19.86,49.35-26.23,6.34-3.2,11.5-5.71,15.08-7.38,1.79-.85,3.19-1.47,4.14-1.91L456,403l.37-.14-.35.19-1.06.53-4.09,2c-3.56,1.72-8.69,4.27-15,7.52-12.65,6.45-30,15.85-49.26,26.37l.08-.39c.82,1.11,1.71,2.29,2.6,3.48l12.67,17-.31-.08,40.16-18.88,11.72-5.46,3.14-1.44.82-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.89,405.43a8.88,8.88,0,0,1,1.36.41c.87.27,2.09.75,3.61,1.36,3,1.26,7.08,3.18,11.46,5.55s8.25,4.65,11,6.37c1.38.86,2.49,1.58,3.24,2.09a7.19,7.19,0,0,1,1.15.84,8.73,8.73,0,0,1-1.25-.67l-3.33-1.94c-2.81-1.64-6.7-3.88-11.07-6.24s-8.4-4.32-11.36-5.66c-1.49-.65-2.69-1.18-3.54-1.51A6.84,6.84,0,0,1,386.89,405.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.75,458.47a4.55,4.55,0,0,1,.75-.85l2.19-2.18c1.86-1.81,4.45-4.3,7.34-7,1.47-1.36,2.86-2.67,4.13-3.86l0,.38c-2.2-1.33-4.06-2.47-5.36-3.29a14.17,14.17,0,0,1-2-1.37,14.66,14.66,0,0,1,2.17,1.12c1.34.75,3.24,1.83,5.45,3.13l.28.16-.24.22-4.1,3.89c-2.89,2.73-5.52,5.17-7.45,6.92l-2.3,2.06A5.76,5.76,0,0,1,435.75,458.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.86,335.67c.5,0,17.93.88,21.24,4.6s10.69,60.16,10.69,60.16c-3.8.49-8.16,2.43-10.51,3.44l-29.42,14.72-15-9.44a3.22,3.22,0,0,1-.62-4.94h0L396,341.81a25.36,25.36,0,0,1,8.34-4.27C409.48,336,432.86,335.67,432.86,335.67Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.68,339.6s-5.31.85-7.5,4c-5.14,7.3-21.16,33.37-24,39.68-3,6.68-1.22,11.33,1.25,13.71,3.6,3.47,12.8,3.85,18.09-1.18,2.27-2.16,14.78-12.26,14.78-12.26Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.14,349.24a4.06,4.06,0,0,0,.17.55l.55,1.53c.46,1.33,1.09,3.28,1.8,5.7,1.43,4.85,3.13,11.62,4.92,19.12s3.33,14.29,4.48,19.24c.58,2.47,1.06,4.45,1.41,5.82.17.66.31,1.19.42,1.58a2,2,0,0,0,.17.54s0-.19-.1-.56-.21-.92-.35-1.59c-.32-1.42-.76-3.4-1.3-5.84-1.09-4.94-2.59-11.76-4.37-19.27s-3.54-14.28-5-19.11c-.74-2.42-1.42-4.36-1.92-5.68-.25-.63-.46-1.14-.61-1.51A2.92,2.92,0,0,0,395.14,349.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.59,337.51s4.17-.07,9,4.46c2,1.88,25,35.83,27.1,45.21,1.23,5.44-5.31,16.17-11.63,15.27-8.27-1.19-38.76-15-38.76-15l7.88-14.8,17.46,3.84-12.07-13.62-.28-25.12",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.73,380.46a1.48,1.48,0,0,0,.33-.17l.9-.55,3.25-2.06c2.74-1.76,6.52-4.21,10.67-6.94l2.78-1.83-.25-.05c2.35,3.46,4.43,6.48,6,8.61a25.5,25.5,0,0,0,2.56,3.34l-2.37-3.47c-1.5-2.22-3.54-5.24-5.85-8.68l-.1-.15-.15.1-2.78,1.82c-4.16,2.73-7.91,5.21-10.61,7l-3.19,2.16-.86.61A2.21,2.21,0,0,0,376.73,380.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.07 366.45 440.69 373.53 434.41 385.33 426 379.05 427.07 366.45",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.79,366.87l-9-6.87a1.67,1.67,0,0,0-1.1-.36l-12.3.33a.93.93,0,0,0-.91.91,1.64,1.64,0,0,0,.44,1.33l19.06,15,14.94-1.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.07,366.45s-4.83-4-6-4.31-6.51-.56-6.51-.56l-4.64,2.3,2.67,2.05a4.27,4.27,0,0,0,2.55-1l3.09.39Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.49,364.5l-8.14,2.27-11.57,1a2.51,2.51,0,0,0,2.14,2.7c1.37.23,3.78.54,3.78.54a3.89,3.89,0,0,0,2.22,2.72,6,6,0,0,0,1.61,2.14,1.54,1.54,0,0,0,.34.17c1.08.38,3.11,3.5,4.55,4s9.58-.93,9.58-.93l1.07-12.6Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.76,370.88s-.64.09-1.67.24a32.06,32.06,0,0,1-4,.29,31.44,31.44,0,0,1-4.05-.24c-1-.14-1.66-.27-1.67-.23a2.52,2.52,0,0,0,.44.13c.28.08.7.16,1.21.25a24.83,24.83,0,0,0,8.13-.05,12.31,12.31,0,0,0,1.21-.26A2.19,2.19,0,0,0,418.76,370.88Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,374.06a2,2,0,0,0,.42,1.59,1.36,1.36,0,0,0,1,.4,2.66,2.66,0,0,0,1.05-.24c.3-.13.55-.27.77-.37.42-.22.71-.3.7-.33a1.61,1.61,0,0,0-.77.19,4.89,4.89,0,0,1-1.75.53,1.23,1.23,0,0,1-.87-.33,1.58,1.58,0,0,1-.38-.69A7,7,0,0,0,417,374.06Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.09,374.5a4.23,4.23,0,0,0,.86.27,21,21,0,0,0,2.13.39,19.43,19.43,0,0,0,2.17.15,3.07,3.07,0,0,0,.9-.05c0-.06-1.37-.11-3-.32S411.1,374.43,411.09,374.5Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.94,378.16a2.3,2.3,0,0,0,1.28.65,2.12,2.12,0,0,0,1.44-.07c0-.06-.64,0-1.39-.14S417,378.1,416.94,378.16Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.08,377.85c0,.06.36.18.84.27a1.77,1.77,0,0,0,.89.06,2,2,0,0,0-.84-.27A1.91,1.91,0,0,0,414.08,377.85Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.35,366.77a21.74,21.74,0,0,0,3.8-1c1-.33,2-.66,2.64-.91a5,5,0,0,0,1.06-.48,7.23,7.23,0,0,0-1.11.33l-2.65.85-2.65.87A10.66,10.66,0,0,0,413.35,366.77Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.47,369s.91-.26,0-1.71-3.64.09-3.64.09l-3.52,1.83s-.87,1.73.05,2.25l.65.91s-1.41,1.27-.94,2.48a1.82,1.82,0,0,0,1.79,1.12s-.29,2.38.43,3.35a2.61,2.61,0,0,0,1.43,1.08,4.28,4.28,0,0,0,2.79,2.74c2.26.72,3.45.83,4.13-.1a10.4,10.4,0,0,0,1.14-2.12s5.06-2.3,5.24-3.59,0-1.44,0-1.44a2.46,2.46,0,0,0,0-1.89c-.45-.82-2.43-.24-2.43-.24l-6.35,1.11s5.15-2.07,5.79-2.8.06-1.72-2-1.6-8.17.91-8.17.91a1.78,1.78,0,0,1,.75-.73c.42-.15,1.72-.81,1.72-.81Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.43,378.38c0,.06,2.59-.44,5.75-1.12s5.72-1.27,5.71-1.33-2.59.44-5.75,1.12S399.41,378.32,399.43,378.38Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.21,382a8.31,8.31,0,0,0,1.86-.37c.51-.14,1-.28,1.28-.4a3.25,3.25,0,0,0,.37-.18.29.29,0,0,0,.1-.08s0-.06,0,0-.79.22-1.79.49A9,9,0,0,0,402.21,382Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.2,375.48a26.11,26.11,0,0,0,2.78-.27c1.53-.17,2.77-.25,2.77-.32a14,14,0,0,0-2.8.1A13.38,13.38,0,0,0,397.2,375.48Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.86,372.16s.56-.27,1.26-.48,1.31-.23,1.31-.29a2.26,2.26,0,0,0-1.37.08A2.41,2.41,0,0,0,395.86,372.16Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,361.06h.23l.66,0,2.42-.16c2-.11,4.86-.19,8-.08a4.39,4.39,0,0,1,2.17.38,8.59,8.59,0,0,1,.85.64l.81.65c1.05.84,2,1.59,2.81,2.24l1.91,1.49.53.4c.12.09.18.13.19.12a1.45,1.45,0,0,0-.17-.16l-.5-.43-1.86-1.54-2.78-2.28-.81-.65a6.62,6.62,0,0,0-.87-.66,2.55,2.55,0,0,0-1.11-.36c-.38,0-.77-.05-1.16-.06a75.25,75.25,0,0,0-8,.15c-1,.08-1.85.16-2.42.22l-.65.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.61,362.6a.6.6,0,0,1,.61-.2h0l.1,0h0a.85.85,0,0,1,.46.3.5.5,0,0,1,0,.64.55.55,0,0,1-.35.14.85.85,0,0,1-.7-.22A.58.58,0,0,1,398.61,362.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.83,397.64a2.79,2.79,0,0,0-.44-.22l-1.29-.59-4.88-2.16-16.89-7.35.09.25c1.61-3,3.37-6.33,5.2-9.75l2.68-5.05-.2.09,17.14,3.63h0a35.09,35.09,0,0,1,8.71,4.44c.95.67,1.67,1.24,2.15,1.62l.54.44c.13.1.19.15.2.14l-.17-.17-.52-.47c-.46-.41-1.16-1-2.11-1.69a34.07,34.07,0,0,0-8.7-4.58h0l-17.12-3.7-.13,0-.07.12-2.69,5-5.18,9.75-.09.17.17.08,16.95,7.22,4.91,2.06,1.32.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.33,365.27a13.56,13.56,0,0,0,1.32,1.82c.86,1.09,2.06,2.58,3.44,4.19s2.65,3.05,3.63,4a11.44,11.44,0,0,0,1.22,1.11c.17.11.28.22.44.19a.11.11,0,0,0,.05-.13s0,0,0,0,0,.09,0,.1a.88.88,0,0,1-.33-.23c-.28-.26-.66-.67-1.13-1.18-.92-1-2.16-2.48-3.53-4.09l-3.52-4.13A13.35,13.35,0,0,0,448.33,365.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.38,358.13c.07,0-.08-1.11,0-2.9a19,19,0,0,1,.44-3.1A19.34,19.34,0,0,1,449,345.2a19.3,19.3,0,0,1,2-2.38c1.28-1.26,2.21-1.87,2.17-1.93a3.28,3.28,0,0,0-.67.4,7.73,7.73,0,0,0-.75.55c-.27.23-.61.47-.93.79a17.82,17.82,0,0,0-2.13,2.37,19.46,19.46,0,0,0-2,3.36,20.49,20.49,0,0,0-1.22,3.7,17.08,17.08,0,0,0-.37,3.16,12.15,12.15,0,0,0,0,1.22,7,7,0,0,0,.09.92A2.55,2.55,0,0,0,445.38,358.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.29,409.74c0-.06-.89,0-2.31-.14a22.06,22.06,0,0,1-5.42-1.18,21.48,21.48,0,0,1-4.93-2.55c-1.18-.81-1.84-1.41-1.88-1.36s.13.18.42.47a14.31,14.31,0,0,0,1.3,1.1,19,19,0,0,0,5,2.68,19.17,19.17,0,0,0,5.53,1.1,14.53,14.53,0,0,0,1.71,0C424.08,409.8,424.3,409.77,424.29,409.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.72,393.54a3.39,3.39,0,0,0,.44.63c.3.39.74.94,1.31,1.62,1.14,1.35,2.77,3.16,4.66,5.07s3.71,3.55,5.05,4.69c.67.57,1.22,1,1.61,1.33a3,3,0,0,0,.63.44s-.18-.22-.54-.55l-1.53-1.41c-1.29-1.19-3.06-2.86-5-4.76s-3.55-3.68-4.73-5l-1.4-1.55C414.93,393.71,414.74,393.52,414.72,393.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.83,319.19a64.41,64.41,0,0,0,1.31-10.87,22.27,22.27,0,0,0-2.31-10.61c-.26-.48-2.36-3.72-2.9-3.59-.39.09,1.05,3.18.9,3.54a18.84,18.84,0,0,0-.62,11.15,49.15,49.15,0,0,0,3.62,10.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.22,342c-.37-2.56-.67-4.57-.69-4.57s-8.9.3-10.65-8.32c-.85-4.16-1.89-12.89-2.75-20.79a16.39,16.39,0,0,1,13.24-17.85l.83-.16c9.09-1.19,15.18,5.87,16.11,15l4.29,31.8L432.06,340A11.54,11.54,0,0,1,413.22,342Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.53,337.45A21.27,21.27,0,0,0,423.15,332s-1.55,6.81-10.32,7.67Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.59,316.75a1.26,1.26,0,0,0,1.43,1,1.2,1.2,0,0,0,1.06-1.36,1.25,1.25,0,0,0-1.43-1A1.2,1.2,0,0,0,403.59,316.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.66,311.58c.19.13,1-.74,2.32-1s2.43.22,2.54,0-.15-.34-.64-.57a3.42,3.42,0,0,0-2.07-.23,3.25,3.25,0,0,0-1.8,1C401.66,311.21,401.57,311.52,401.66,311.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.19,315a1.26,1.26,0,0,0,1.43,1,1.21,1.21,0,0,0,1.06-1.36,1.27,1.27,0,0,0-1.43-1A1.21,1.21,0,0,0,415.19,315Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.77,309.64c.19.14,1-.73,2.32-1s2.43.23,2.54,0-.15-.35-.64-.58a3.42,3.42,0,0,0-2.07-.23,3.25,3.25,0,0,0-1.8,1C414.77,309.27,414.68,309.59,414.77,309.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,320.76a8.35,8.35,0,0,0-2.23,0c-.34,0-.68,0-.78-.2a1.74,1.74,0,0,1,0-1.05c.16-.88.33-1.8.51-2.77a44.87,44.87,0,0,0,1-7.19,45.26,45.26,0,0,0-1.54,7.09c-.16,1-.32,1.9-.47,2.78a2,2,0,0,0,.08,1.37.91.91,0,0,0,.65.39,2.79,2.79,0,0,0,.6,0A9.57,9.57,0,0,0,412,320.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,320.93c-.22,0,0,1.47-1,2.73s-2.6,1.39-2.58,1.59.4.22,1,.11a3.68,3.68,0,0,0,2.17-1.25,3.21,3.21,0,0,0,.73-2.27C416.36,321.23,416.13,320.9,416,320.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.82,304.24c.2.34,1.49-.09,3.09-.2s2.93.08,3.08-.28c.06-.18-.22-.47-.8-.73a5.45,5.45,0,0,0-4.7.37C414,303.74,413.73,304.08,413.82,304.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.37,307.06c.29.26,1.15-.23,2.24-.45s2.07-.18,2.23-.54c.06-.17-.14-.45-.6-.65a3.13,3.13,0,0,0-1.92-.15,3.19,3.19,0,0,0-1.68,1C401.31,306.6,401.24,306.94,401.37,307.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.82,311.86c.14-.1,5.61-2.89,6.54,3.05s-5.22,5.66-5.26,5.49S429.82,311.86,429.82,311.86Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.56,317.86s.12.06.31.11a1.06,1.06,0,0,0,.77-.1,2.6,2.6,0,0,0,.83-2.49,3.5,3.5,0,0,0-.53-1.44,1.24,1.24,0,0,0-.9-.67.54.54,0,0,0-.57.38c-.05.18,0,.29,0,.31s-.14-.08-.13-.33a.63.63,0,0,1,.18-.41A.76.76,0,0,1,433,313a1.43,1.43,0,0,1,1.23.75,3.56,3.56,0,0,1,.62,1.6,2.7,2.7,0,0,1-1.11,2.8,1.08,1.08,0,0,1-1,0C432.6,318,432.54,317.88,432.56,317.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.52,297.92c-1-.39,1.39-3.94,3.59-5.37,3.34-2.15,8.65-4,12.09-3.52,4.14.54,7.73,2,10.26,5.35a23.55,23.55,0,0,1,4.41,11.56,7.26,7.26,0,0,1-.3,3.76c-.64,1.44-2.11,2.5-1.77,4.31a2.55,2.55,0,0,1-.35,1.91c-.92,1.32-2.41.43-3.18-.57-1.66-2.14-2.22-4.9-2.73-7.56a17.49,17.49,0,0,1-.46-5.71c.14-1,.47-2,.56-3.09a3.61,3.61,0,0,0-.87-2.9,3.22,3.22,0,0,0-.55-.42,6.28,6.28,0,0,0-6.34-.26c-3.17,1.68-8.63,4.3-10.3,3.39a9.26,9.26,0,0,1-3.06-2.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.56,174.86c-1.21-4-2.68-8.05-2.5-12.22l-2.56-7.53a12.88,12.88,0,0,0-14.69,13.46,62.45,62.45,0,0,0,1.31,7c.39,2.34.35,4.92-1,6.88-.61.87-1.5,1.67-1.56,2.74-.07,1.36,1.35,2.43,2.71,2.49a7.78,7.78,0,0,0,3.86-1.23,4.26,4.26,0,0,0,8.11,2.32c-.18,1.86,2.18,3.19,4,2.6s2.87-2.39,3.39-4.19C104.73,183.17,103.76,178.86,102.56,174.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.68 406.9 106.13 399.04 119.84 398.76 119.47 408.38 114.43 411.3 105.68 406.9",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.8,406.6l0,.9S134.89,414,135,417l-30.33-1,.74-10.08A17.37,17.37,0,0,0,119.8,406.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.35,409.22a1.23,1.23,0,0,0-.9,1.39,1.17,1.17,0,0,0,1.36.9,1.3,1.3,0,0,0,1-1.47,1.24,1.24,0,0,0-1.53-.78",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.64,416l.18-2.43,29,1.82s1.33.63,1.14,1.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.88,407.59c0,.14-.75.19-1.5.64s-1.15,1.06-1.28,1,.11-.91,1-1.44S119.92,407.45,119.88,407.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,409c0,.15-.62.38-1.14,1s-.69,1.27-.84,1.26-.21-.85.45-1.6S123,408.86,123,409Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.71,412.87c-.14,0-.32-.72.08-1.52s1.11-1.1,1.17-1-.38.54-.71,1.2S124.85,412.86,124.71,412.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.74 389.35 106.93 412.72 96.23 410.75 96.39 387.69 109.74 389.35",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.35,406.31s7,6.11,11.19,2l.71,2.31,2.54,16.17a2.1,2.1,0,0,1-1.5,2.39,2.15,2.15,0,0,1-2.16-.67c-2.8-3.24-13-15.24-12.75-16.67l.48-3.85a2,2,0,0,1,1.49-1.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.91,429.22,94.53,410.48l-.09.84a2.3,2.3,0,0,0,.56,1.94c1.12,1.88,4.33,6.17,12.07,15.23a2.13,2.13,0,0,0,1.84.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.2,408.24a1.22,1.22,0,0,1,.17,1.65,1.25,1.25,0,0,1-1.67.17,1.18,1.18,0,1,1,1.59-1.74",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.19,420a6.4,6.4,0,0,1,2-1.35,6.63,6.63,0,0,1,2.39-.18c0-.05-.22-.23-.69-.35a3.3,3.3,0,0,0-1.86.12,3.26,3.26,0,0,0-1.5,1.07C105.21,419.72,105.14,420,105.19,420Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.35,422.85a19.08,19.08,0,0,1,1.9-.66,17.92,17.92,0,0,1,2,0,2.37,2.37,0,0,0-2.1-.4C106.93,422,106.25,422.79,106.35,422.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,416.33a19.19,19.19,0,0,1,2.86-1.21,21.22,21.22,0,0,1,3.1-.36,4.8,4.8,0,0,0-3.22-.06A4.54,4.54,0,0,0,102.86,416.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,411.51c0,.13,1.21-.21,2.69-.1s2.59.58,2.65.46a5.33,5.33,0,0,0-5.34-.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.56,411.46a1.49,1.49,0,0,0,0-.76,5.19,5.19,0,0,0-.76-1.93,2.36,2.36,0,0,0-1.11-1,.87.87,0,0,0-.94.25,1.28,1.28,0,0,0-.25.92,3,3,0,0,0,2.8,2.5,3.43,3.43,0,0,0,3.24-2,1.1,1.1,0,0,0,0-1,.83.83,0,0,0-.89-.36,2.89,2.89,0,0,0-1.3.77,5.8,5.8,0,0,0-1.27,1.64,1.91,1.91,0,0,0-.27.71,9.92,9.92,0,0,1,1.75-2.12,2.8,2.8,0,0,1,1.15-.65.46.46,0,0,1,.49.2.76.76,0,0,1,0,.64,3.07,3.07,0,0,1-2.83,1.69,2.58,2.58,0,0,1-2.41-2.09,1,1,0,0,1,.15-.65.47.47,0,0,1,.52-.14,2.14,2.14,0,0,1,1,.86A7.32,7.32,0,0,1,106.56,411.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.55,241.11s2.14,10,4.59,28.12c2.24,16.49-5.09,64.61-7,74.69-1.29,6.86-7.68,41.15-15,62l-10.76-.19s8.19-69.64,8-76.91-2.11-46-2.11-46L112,253.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.94,237.85c.87.31,19.78,14.13,19.78,14.13s9,79.77,9.65,90.25-15,63.46-15,63.46l-14.82-.25s.9-35.17,3.41-45.88,2.56-13.33,1.22-20-13-42.34-16.45-60.14S94.94,237.85,94.94,237.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.17,273.39a1.66,1.66,0,0,1,.06.34l.12,1c.1.91.24,2.22.42,3.88.36,3.38.84,8.26,1.35,14.3s1.09,13.24,1.5,21.25c.18,4,.37,8.21.33,12.58,0,1.1-.07,2.2-.1,3.31s-.18,2.24-.3,3.36c-.35,2.23-.76,4.48-1.18,6.76-3.53,18.17-7.12,34.53-9.69,46.38-1.3,5.91-2.36,10.69-3.1,14-.37,1.64-.67,2.92-.87,3.81l-.24,1a1.89,1.89,0,0,1-.1.33,2.75,2.75,0,0,1,.06-.34c0-.25.11-.58.19-1,.19-.9.45-2.18.79-3.82.71-3.34,1.72-8.14,3-14.05,2.48-11.87,6-28.24,9.55-46.41,2.25-9,1.55-17.91,1.28-25.9s-.92-15.2-1.4-21.24-.91-10.93-1.21-14.31c-.14-1.67-.26-3-.34-3.89,0-.43-.06-.76-.08-1A2.31,2.31,0,0,1,122.17,273.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.85,147.35a21.46,21.46,0,0,1,16.61-8.26c3.77-.06,5.33.72,8,1.45a11.89,11.89,0,0,1,6.79,4.49,20.08,20.08,0,0,1,3.91,9.11,28.1,28.1,0,0,1-1.37,11.14c-1.66,4.72-2.12,6-4.14,8.82l-5.91,1.47c-4.81.16-9.69.32-14.37-.77s-9.24-3.62-11.75-7.73C93.17,161.37,94.62,152.53,98.85,147.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.6,147.29l11.61-4.61,3,.35c6.83,0,11.53,7.55,11.58,13.08.05,6.14-.13,13.64-1.11,18.16-2,9.1-9.73,9.86-9.73,9.86s.16,4.85.22,7.91c-6.5,7.23-13.48,7.56-18.77-1.23l.1-40.4A3.24,3.24,0,0,1,106.6,147.29Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.05,163.58a1.18,1.18,0,0,1-1.2,1.12,1.12,1.12,0,0,1-1.15-1.13,1.18,1.18,0,0,1,1.2-1.12A1.12,1.12,0,0,1,130.05,163.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.74,159.18c-.16.14-1-.56-2.28-.63s-2.23.52-2.36.35.1-.34.52-.61a3.24,3.24,0,0,1,1.9-.47,3,3,0,0,1,1.8.69C130.7,158.83,130.81,159.11,130.74,159.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,169.11a8.5,8.5,0,0,1,2.07-.25c.33,0,.64-.07.71-.28a1.62,1.62,0,0,0-.17-1c-.26-.8-.53-1.64-.82-2.52a42.24,42.24,0,0,1-1.79-6.56,43.2,43.2,0,0,1,2.32,6.4l.78,2.53a1.84,1.84,0,0,1,.09,1.28.8.8,0,0,1-.55.44,2.36,2.36,0,0,1-.56,0A7.43,7.43,0,0,1,122.6,169.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,184.12a23.42,23.42,0,0,1-12.12-4s2.93,6.54,12.16,6.19Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.71,152.74c-.23.3-1.19,0-2.32.07s-2.1.28-2.33,0,0-.44.44-.73a3.44,3.44,0,0,1,1.88-.55,3.48,3.48,0,0,1,1.88.5C130.67,152.3,130.81,152.6,130.71,152.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.17,163.12a1.17,1.17,0,0,0,1.11,1.21,1.14,1.14,0,0,0,1.24-1,1.18,1.18,0,0,0-1.12-1.21A1.12,1.12,0,0,0,116.17,163.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.59,158.69c.15.15,1-.49,2.32-.47s2.19.68,2.33.53-.08-.35-.48-.65a3.23,3.23,0,0,0-1.86-.61,3.13,3.13,0,0,0-1.85.56C113.66,158.34,113.52,158.62,113.59,158.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.35,153.5c.25.29,1.23,0,2.41,0s2.17.24,2.4-.06c.11-.15,0-.44-.47-.72a3.63,3.63,0,0,0-2-.5,3.57,3.57,0,0,0-1.93.54C114.39,153.06,114.25,153.36,114.35,153.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.11,165.84c0-.69-.67-2.34-1.34-2.48-1.78-.38-5-.42-5.32,4.16-.39,6.26,6,5.35,6,5.17S105,168.2,105.11,165.84Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,170.3s-.11.07-.3.15a1.13,1.13,0,0,1-.82,0,2.7,2.7,0,0,1-1.1-2.49,3.62,3.62,0,0,1,.4-1.55,1.28,1.28,0,0,1,.87-.78.55.55,0,0,1,.63.34c.07.18,0,.3.06.31s.14-.1.1-.36a.63.63,0,0,0-.22-.4.79.79,0,0,0-.59-.2,1.52,1.52,0,0,0-1.2.9,3.67,3.67,0,0,0-.48,1.72,2.83,2.83,0,0,0,1.42,2.8,1.21,1.21,0,0,0,1-.1C102.84,170.45,102.88,170.32,102.86,170.3Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52,163.37l1.59,1.65c6.86-6.57,20.28-23,19.53-22a20.08,20.08,0,0,0-9.81-1.07c-5.1.87-14.78,3.43-14.63,9.45S103.52,163.37,103.52,163.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.43,162a1.76,1.76,0,0,1,.09-.36,7.19,7.19,0,0,1,.43-1,9.21,9.21,0,0,1,2.61-2.94,17.13,17.13,0,0,1,5.27-2.53c2.09-.68,4.45-1.21,6.77-2.21a30.32,30.32,0,0,0,6.18-3.46,30.89,30.89,0,0,0,4.36-3.81,34.32,34.32,0,0,0,2.53-3l.62-.86c.15-.2.23-.3.24-.29a1.34,1.34,0,0,1-.18.33c-.13.2-.32.51-.58.9a29.6,29.6,0,0,1-6.82,7,29.88,29.88,0,0,1-6.23,3.52,67.08,67.08,0,0,1-6.8,2.19,17.48,17.48,0,0,0-5.22,2.43,9.38,9.38,0,0,0-2.64,2.83C94.6,161.5,94.46,162,94.43,162Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.92,172a14.82,14.82,0,0,0-2.61-1.45,1.14,1.14,0,0,0-.54-.11.94.94,0,0,0-.59.41,2.47,2.47,0,0,0,0,2.78,2.33,2.33,0,0,0,2.51.92,2.8,2.8,0,0,0,1.64-2.27Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.66,174a2,2,0,0,1-1.51.6,2.47,2.47,0,0,1-1.72-.64,2.43,2.43,0,0,1-.82-2.08,2.39,2.39,0,0,1,.42-1.13,1.66,1.66,0,0,1,.45-.42.62.62,0,0,1,.38-.06,1,1,0,0,1,.29.11l1.52.84A5.79,5.79,0,0,1,122,172a6.12,6.12,0,0,1-1.5-.6l-1.56-.75c-.15-.07-.22-.08-.29,0a1.11,1.11,0,0,0-.3.31,1.89,1.89,0,0,0-.33.92,2.06,2.06,0,0,0,.66,1.73,2.17,2.17,0,0,0,1.44.62A5,5,0,0,0,121.66,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.89,173.49a2.2,2.2,0,1,1-2.2-2.2A2.21,2.21,0,0,1,104.89,173.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.07,190.58s6.54,2.27,8.48,8.09,4.59,13.17,4.59,13.17l-12.4,3.47Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,191l8.36-3.18,4.12-1.46c1.85,3.13,5.93,4.67,10.09,4.64,4.4,0,6.32-1.88,8.51-4.61l1.71.74,10.33,3.11,5.12,21.5-1.06,29.39,4.48,21.25c-15.85,6.44-42.63,5.05-59.55-2.64L94.7,236l-4.12-42.45Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.65,214.31l.23.37L127.07,196l-6.92,5.64s7.19,20.2,11.51,27.32c4.2,6.91,12.69,9.51,17,.77,2.19-4.47-2.62-17.46-2.62-17.46Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.61,220.45,127.19,196l3.3-10.32a8.09,8.09,0,0,0,.25-4.57c-.59-2.52-1.53-6.25-2.05-7-.78-1.13-1.17-.51-1.17-.51l-8.77,24.48,3.06,8.21",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.81,206.28a2.4,2.4,0,0,1-.25-.54l-.64-1.59-2.31-6,0-.05,0-.06c2.07-5.86,5.13-14.52,8.67-24.51v-.05a.65.65,0,0,1,.8-.23,1.44,1.44,0,0,1,.54.4,3,3,0,0,1,.61,1c.27.73.48,1.46.69,2.21.41,1.49.8,3,1.14,4.56a8.39,8.39,0,0,1-.25,4l-1.18,3.66c-.77,2.39-1.51,4.71-2.22,6.92l0-.2,11,17.66,3.12,5.1.82,1.37a3.85,3.85,0,0,1,.26.48s-.13-.14-.33-.44-.52-.77-.88-1.33l-3.25-5L127,196.1l-.06-.1,0-.11c.71-2.21,1.44-4.53,2.21-6.93s2-4.84,1.4-7.42c-.33-1.52-.72-3-1.12-4.52-.21-.74-.42-1.47-.68-2.16a2.36,2.36,0,0,0-.51-.89.9.9,0,0,0-.34-.27.15.15,0,0,0-.19,0l0-.05-8.86,24.45V198c.92,2.58,1.66,4.63,2.18,6.08.23.68.42,1.22.56,1.62A4.74,4.74,0,0,1,121.81,206.28Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.59,204l1.11-3.72s6.61-13.58,7-15.28,2.31-8,.94-9.21c0,0,1-3.24-.3-3.48s-1.93,1.49-1.93,1.49.2-1.76-.47-2.06c-1-.48-1.88,1-1.88,1h0s-1.14-.9-2.42,1.21c0,0-5.68,9.64-6.39,10.29s-1.86-1.35-1.86-1.35a13.66,13.66,0,0,0-1.92-3.87c-.77-.84-2.07-.17-2.07-.17a25.88,25.88,0,0,0,1.29,7.85c.6,1.83,2.19,8.38,2.19,8.38l-2.8,6",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,201.13a2,2,0,0,1,.15-.42c.14-.3.31-.69.52-1.18.48-1.08,1.16-2.58,2-4.47v.09c-.53-2-1.17-4.33-1.89-7-.33-1.35-.85-2.77-1.15-4.32a25,25,0,0,1-.53-4.93v-.14l.12-.06a2.34,2.34,0,0,1,1.71-.2,1.6,1.6,0,0,1,.75.54,5.51,5.51,0,0,1,.49.7,17.78,17.78,0,0,1,1.37,3.12l0,0a4.17,4.17,0,0,0,1,1.22c.22.15.36.17.47.06a5.39,5.39,0,0,0,.49-.66c.65-1,1.27-2,1.91-3l3.86-6.43a4.32,4.32,0,0,1,1.09-1.3,1.54,1.54,0,0,1,1.79-.1l-.38.07a3,3,0,0,1,.84-.93,1.33,1.33,0,0,1,1.32-.19.94.94,0,0,1,.51.55,2.86,2.86,0,0,1,.15.61,5.17,5.17,0,0,1,0,1.18l-.49-.11a2.91,2.91,0,0,1,1.09-1.43,1.56,1.56,0,0,1,.92-.25,1.24,1.24,0,0,1,.5.13,1,1,0,0,1,.37.39,3,3,0,0,1,.16,1.72,9.36,9.36,0,0,1-.34,1.59l-.07-.26a2,2,0,0,1,.51,1.13,6.21,6.21,0,0,1,.06,1.13,15,15,0,0,1-.25,2.15c-.24,1.39-.58,2.72-.92,4a13.53,13.53,0,0,1-.59,1.87c-.24.6-.5,1.17-.75,1.72l-1.48,3.2c-1.92,4-3.53,7.3-4.64,9.52h0l-.87,2.75c-.1.28-.18.51-.24.7a1.13,1.13,0,0,1-.1.24.88.88,0,0,1,0-.25c0-.2.11-.43.18-.72.19-.68.45-1.61.77-2.78h0l4.48-9.59c.47-1,1-2.09,1.45-3.21.25-.55.49-1.13.73-1.71a13.52,13.52,0,0,0,.56-1.83c.33-1.27.66-2.58.89-3.95a14.38,14.38,0,0,0,.22-2.08,2.82,2.82,0,0,0-.41-1.88l-.11-.13,0-.13a9.3,9.3,0,0,0,.32-1.5,2.66,2.66,0,0,0-.11-1.42c-.14-.34-.72-.31-1.08-.08a2.48,2.48,0,0,0-.88,1.17l-.67,1.67.17-1.78a4.7,4.7,0,0,0,0-1.06c0-.34-.16-.7-.35-.75-.53-.26-1.17.32-1.51.9l-.15.24L123,173a1,1,0,0,0-1.17.13,3.78,3.78,0,0,0-.94,1.14c-1.31,2.2-2.6,4.36-3.87,6.43-.64,1-1.27,2.05-1.93,3-.18.24-.33.48-.56.74a.74.74,0,0,1-.6.2,1.25,1.25,0,0,1-.51-.22,4.85,4.85,0,0,1-1.15-1.39v0a17.1,17.1,0,0,0-1.31-3c-.28-.45-.56-.92-1-1a1.86,1.86,0,0,0-1.36.16l.12-.2a24.94,24.94,0,0,0,.49,4.83c.28,1.54.78,2.92,1.1,4.3.69,2.7,1.29,5.08,1.79,7.06l0,0,0,0-2.13,4.42-.58,1.15A1.81,1.81,0,0,1,109.13,201.13Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05,183.93a7.86,7.86,0,0,0,1.06-1.46,30,30,0,0,0,2-3.86,38.05,38.05,0,0,0,1.53-4.09,8.64,8.64,0,0,0,.43-1.75,13.84,13.84,0,0,0-.65,1.68c-.38,1.05-.92,2.48-1.61,4a43.06,43.06,0,0,1-1.94,3.87A15.34,15.34,0,0,0,118.05,183.93Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,185a8.55,8.55,0,0,0,.83-1.52c.47-1,1.09-2.29,1.72-3.79s1.11-2.91,1.42-3.93a8.11,8.11,0,0,0,.4-1.68,10.12,10.12,0,0,0-.62,1.61c-.36,1-.88,2.37-1.5,3.87s-1.17,2.74-1.63,3.82A9.18,9.18,0,0,0,121,185Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.17,185.57a5.77,5.77,0,0,0,.84-1.28,22.77,22.77,0,0,0,1.49-3.39,28.63,28.63,0,0,0,1-3.56,6.49,6.49,0,0,0,.22-1.52c-.11,0-.57,2.27-1.5,5a35.76,35.76,0,0,1-1.38,3.39A11.27,11.27,0,0,0,124.17,185.57Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.22,213.62S88.7,235,91,238.42c4.28,6.22,13.37,7.57,16.74,1,3.61-7,11.92-39.13,11.92-39.13l-8.34-3.71L100,220.4l-3.82-10.81Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,191s-8.73,3.58-9.4,15.42c-.17,2.89,1.78,18.56,1.78,18.56l16.28-7.12L95.7,204Z",
    style: {
      fill: "#17C1E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,219.82a64.23,64.23,0,0,1-2.87-7.49,64.09,64.09,0,0,1-2.38-7.66,60.55,60.55,0,0,1,2.87,7.49A60.8,60.8,0,0,1,100,219.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.56,168.64a4.76,4.76,0,0,1-1.34-1.36,12.28,12.28,0,0,1-2.33-8.75,5,5,0,0,1,.48-1.85,15.51,15.51,0,0,0,3.19,12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.91,201.45a40.05,40.05,0,0,1,1.5,6.21c.56,2.77,1,5.13,1,5.94l0,.39-.18-.32c-.11-.21-.15-.32-.13-.33s.11.06.27.23l-.15.07c-.26-.78-.8-3.11-1.36-5.88A39.2,39.2,0,0,1,136.91,201.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,230.88c-.63-3.25.52-8.59,3-10.48",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,220.4c0,.07-.44.47-1,1.31a12.09,12.09,0,0,0-1.5,3.61,23.14,23.14,0,0,0-.56,5.56,3.7,3.7,0,0,1-.35-1.64,13.21,13.21,0,0,1,.41-4.05,9.91,9.91,0,0,1,1.7-3.69C99.37,220.66,100,220.35,100,220.4Z",
    style: {
      fill: "#ff9a6c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselSvg3);
export default __webpack_public_path__ + "static/media/carouselSvg3.538f4ccaee12ece1b938bc56542c2df9.svg";
export { ForwardRef as ReactComponent };